// import {
//   IonContent,
//   IonPage,
//   IonButton,
//   IonItemDivider,
//   IonRow,
//   IonInput,
//   IonLabel,
//   IonItem,
//   useIonRouter,
//   IonCol,
//   useIonAlert,
//   IonLoading,
//   IonImg,
//   IonText,
//   IonIcon
// } from "@ionic/react";
// import { useForm } from "react-hook-form";
// import { Link, useHistory, useLocation, useParams } from "react-router-dom";
// import { useState, useEffect, useContext, useRef } from "react";
// import "./Home.css";
// import UserHead from "./UserHead";
// import Foot from "./Foot";
// import AuthService from "../Services/auth.service";
// import "./Login.css";
// import { Modal, ModalHeader } from "react-bootstrap";

// // import "@codetrix-studio/capacitor-google-auth";
// // import { Plugins } from '@capacitor/core';

// import { Capacitor } from "@capacitor/core"
// import validator from 'validator'
// import Authservice from "../Services/user.service";
// import CustomSpin from "../components/customSpin";
// import { AppContext } from "../components/AppContext";
// import { auth, provider, signInWithPopup } from "../Services/firebase-config";

// import { PhoneAuthProvider, RecaptchaVerifier, getAuth, signInWithPhoneNumber } from "firebase/auth";
// import PhoneInput from 'react-phone-number-input';
// import 'react-phone-number-input/style.css'
// import { parsePhoneNumberFromString } from 'libphonenumber-js';
// import { closeicon, logo } from "../theme/imagePath";
// import { close, eye, eyeOff, home, downloadOutline,logoGoogle } from "ionicons/icons";
// import HeadFoot from "./Head";
// import { fetchUserDetails } from "../components/userInformation";


// const Tab2: React.FC = () => {
//   const history = useHistory();
//   const params: any = useParams()
//   const { handleSubmit } = useForm({
//     mode: "onTouched",
//     reValidateMode: "onChange",
//   });
//   const [email, setEmail] = useState("");
//   const [passemail, setPassemail] = useState("");

//   const router = useIonRouter();
//   const [userid] = useState(sessionStorage.getItem("UserId"));
//   const [usertoken] = useState(sessionStorage.getItem("token"));
//   // var userdata: any = sessionStorage.getItem("UserData");
//   const { userdata } = useContext(AppContext)!;
//   const [showLoading, setShowLoading] = useState(false);
//   const [forpassmodal, setforpassmodal] = useState(false)
//   const inputRef = useRef<HTMLIonInputElement>(null);
//   const errorMessageRef = useRef<HTMLIonTextElement>(null);
//   const [errorMessage, setErrorMessage]: any = useState<string>('');
//   const [msg, setMsg] = useState("");

//   const [password, setPassword] = useState("");
//   const mailpat = /[a-zA-Z0-9]+[\.]?([a-zA-Z0-9]+)?[\@][a-z]{3,9}[\.][a-z]{2,5}/g;
//   const local: any = useLocation()
//   const [path, setPath] = useState(false)
//   var token: any = params.token;
//   console.log("logintkn" + token)
//   const { setUFlag } = useContext(AppContext)!;
//   const { setToken } = useContext(AppContext)!;
//   const { setUserData } = useContext(AppContext)!;
//   const [phone, setPhone] = useState("");
//   const [otp, setOtp] = useState("");
//   const [confirmationResult, setconfirmationResult]: any = useState();
//   const [index, setIndex]: any = useState(0);
//   const [showOtp, setShowOtp]: any = useState(false);
//   const widthSize: any = window.innerWidth;
//   const [isValidPhoneNumber, setIsValidPhoneNumber] = useState(false);
//   var load: any = false;

//   const [logInfo, setLogInfo]: any = useState("")
//   const [showPassword, setShowPassword] = useState(false);

//   //added by me

//   const [deferredPrompt, setDeferredPrompt] = useState<any>(null);
//   const [showInstallButton, setShowInstallButton] = useState(false);

//   useEffect(() => {
//     const handleBeforeInstallPrompt = (e: any) => {
//       e.preventDefault();
//       setDeferredPrompt(e);
//       setShowInstallButton(true);
//     };

//     window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

//     return () => {
//       window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
//     };
//   }, []);


//   const handleInstallClick = () => {
//     if (!deferredPrompt) return;

//     deferredPrompt.prompt();
//     deferredPrompt.userChoice.then((choiceResult: any) => {
//       if (choiceResult.outcome === 'accepted') {
//         console.log('✅ User accepted the install prompt');
//       } else {
//         console.log('❌ User dismissed the install prompt');
//       }
//       setDeferredPrompt(null);
//       setShowInstallButton(false);
//     });
//   };

//   //added by me


//   const [formErrors, setFormErrors] = useState({
//     email: '',
//     password: '',
//     phone: "",
//     otp: ""
//   });
//   const [alert] = useIonAlert();
//   const phoneInputRef = useRef(null)
//   const moveCursorToEnd = (value: any) => {
//     const input: any = phoneInputRef.current;
//     if (widthSize <= 500) {
//       if (input) {
//         setTimeout(() => {
//           input.focus();
//           input.setSelectionRange(input.value.length, input.value.length);
//         }, 0);
//       }
//     }
//     try {
//       const phoneNumberObject: any = parsePhoneNumberFromString(value);
//       setIsValidPhoneNumber(phoneNumberObject ? phoneNumberObject.isValid() : false);
//     } catch (error) {
//       setIsValidPhoneNumber(false);
//       console.log(error)
//     }
//     setPhone(value)
//   };
//   const verifyOTP = () => {
//     // var credential = PhoneAuthProvider.credential(confirmationResult.verificationId, otp);
//     // console.log(credential);
//     const errors: any = {};
//     if (otp === undefined || otp === "" || otp == null) {
//       errors.otp = "Enter OTP"
//     }
//     setFormErrors(errors);
//     console.log(formErrors)
//     if (Object.keys(errors).length === 0) {
//       confirmationResult.confirm(otp).then((result: any) => {
//         // User signed in successfully.
//         const user = result.user;
//         console.log(result);
//         setShowLoading(true);
//         AuthService.mobileLogin(phone)
//           .then((response) => {
//             if (response.data.responseText.startsWith("SUCCESS")) {
//               if (response.data.userModel.uflag === "false") {
//                 alert("Your account is not active, Please contact Atmagram")
//               }
//               else {
//                 console.log(response.data)
//                 sessionStorage.setItem("token", response.data.userToken);
//                 sessionStorage.setItem("UserId", response.data.userModel.userId);
//                 sessionStorage.setItem("uFlag", response.data.userModel.uflag);
//                 sessionStorage.setItem("UserData", response.data.userModel.role);
//                 sessionStorage.setItem("Email", response.data.userModel.email);
//                 sessionStorage.setItem("Phone", response.data.userModel.mobileNumber);
//                 setUFlag(response.data.userModel.uflag)
//                 setToken(response.data.userToken)
//                 setUserData(response.data.userModel.role)
//                 if (response.data.userModel.address !== null) {
//                   sessionStorage.setItem("Address", response.data.userModel.address);
//                 }
//                 if (response.data.userModel.firstName !== null) {
//                   sessionStorage.setItem("Name", response.data.userModel.firstName);
//                 }
//                 if (response.data.userModel.lastName !== null) {
//                   sessionStorage.setItem("lastName", response.data.userModel.lastName);
//                 }
//                 var usrRole = response.data.userModel.role;
//                 history.replace("/")

//               }
//               var usrToken = response.data.userToken;
//               if (token != null && token != undefined && token != "") {
//                 Authservice.VerifyMobileChange(token, usrToken).then((response) => {
//                   if (response.data.startsWith("SUCCESS")) {
//                     alert(response.data.split('SUCCESS:')[1]);
//                     token = null;
//                     history.push("/profile")
//                     return;
//                   } else {
//                     alert(response.data.split('ERROR:')[1]);
//                     token = null;
//                     history.replace("/")
//                     return;
//                   }
//                   console.log(response + "mobRes")
//                 })
//                   .catch((error) => {
//                     console.log(error + "mobErr")
//                   });
//               } else {
//                 // if (Capacitor.getPlatform() === "web") {
//                 //   window.location.reload();
//                 // } else {
//                 //   history.goBack();

//                 // }


//               }


//             } else {
//               alert(response.data.responseText.split("ERROR:")[1]);
//             }
//             setShowLoading(false);
//           })
//           .catch((error) => {
//             console.log(error);
//             setShowLoading(false);
//           });

//         // ...
//       }).catch((err: any) => {
//         // User couldn't sign in (bad verification code?)
//         console.log(err.error);
//         alert("Not a valid verification code or Code expired, please try again")


//         // if(error.error.message=='SESSION_EXPIRED'){
//         //   alert("OTP expired");
//         // }else{

//         // }
//         // ...
//       });
//     }


//   }
//   const checkMobile = () => {
//     const errors: any = {};
//     if (phone === undefined || phone === "") {
//       errors.phone = "Mobile Number is required"
//     } else if (!isValidPhoneNumber) {
//       errors.phone = "Enter valid Mobile Number"
//     }
//     setFormErrors(errors);
//     console.log(formErrors)
//     if (Object.keys(errors).length === 0) {
//       setShowLoading(true);
//       AuthService.validMob(phone).then((res) => {
//         setShowLoading(false);
//         if (res.data) {
//           getOTP();
//         } else {
//           alert("Please complete registration. Then only you can login with Atmagram")
//         }

//       }).catch((error) => {
//         console.log(error);
//         setShowLoading(false);
//       });
//     }
//   }

//   const getOTP = () => {
//     let verify = new RecaptchaVerifier('recaptcha-container', {
//       'size': 'normal',
//       'callback': (response: any) => {
//         // reCAPTCHA solved, allow signInWithPhoneNumber.
//         // ...
//       },
//       'expired-callback': () => {
//         // Response expired. Ask user to solve reCAPTCHA again.
//         // ...
//         alert("Response expired. Please solve reCAPTCHA again")
//       }
//     }, auth);

//     signInWithPhoneNumber(auth, phone, verify)
//       .then((confirmationResult) => {
//         // SMS sent. Prompt user to type the code from the message, then sign the
//         // user in with confirmationResult.confirm(code).
//         console.log(confirmationResult);
//         setShowOtp(true)
//         setconfirmationResult(confirmationResult)
//         // ...
//       }).catch((error) => {
//         // Error; SMS not sent
//         console.log("mob error" + error)
//         alert("Something went wrong, please try again later.")
//         // ...
//       });
//   }

//   const fetchDetails = async () => {
//     const details = await fetchUserDetails();
//     console.log(JSON.stringify(details));
//     setLogInfo(JSON.stringify(details));
//   };

//   useEffect(() => {
//     fetchDetails();
//   }, []);

//   useEffect(() => {
//     if (!load) {
//       if (userdata != null) {
//         //history.goForward();
//         // history.replace("/")
//         sessionStorage.clear()
//       }
//       load = true;
//     }

//     console.log(local.state)
//   }, []);

//   const [alertmodal, setAlertmodal] = useState(false)
//   const [alertdata, setAlertdata] = useState("")
//   const ForgetSubmit = () => {
//     setShowLoading(true);
//     AuthService.Forgotpassword(passemail).then((response) => {

//       if (response.data.startsWith("SUCCESS")) {
//         console.log(response.data)
//         var res = response.data.split('SUCCESS:')[1];
//         alertmodalaction(true, "Reset password link sent to your Email Id!")

//         setShowLoading(false);

//       } else {
//         setShowLoading(false);
//         alertmodalaction(true, "Account Not Found")
//       }

//     })
//       .catch((error) => {
//         console.log(error);
//         setShowLoading(false);
//       });
//   };

//   const alertmodalaction = (e: any, data: any) => {
//     setAlertmodal(e)
//     setAlertdata(data)
//   }

//   const alertmodalclose = () => {
//     if (alertdata === "Reset password link sent to your Email Id!") {
//       window.location.reload()
//     }
//     else {
//       setAlertmodal(false)
//       setAlertdata("")
//     }
//   }

//   const handleBlur = () => {
//     const inputValue: any = inputRef.current?.value;
//     const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

//     if (inputValue === "") {
//       setErrorMessage('Please enter a email address');
//       errorMessageRef.current?.setAttribute('aria-errormessage', 'email-error');
//     }
//     else if (!emailPattern.test(inputValue!)) {
//       setErrorMessage('Please enter a valid email address');
//       errorMessageRef.current?.setAttribute('aria-errormessage', 'email-error');
//     } else {
//       setErrorMessage('');
//       errorMessageRef.current?.removeAttribute('aria-errormessage');
//     }
//   };
//   const Submit = () => {
//     const errors: any = {};

//     if (email.trim() === '') {
//       errors.email = 'Email is required';
//     }
//     else if (validator.isEmail(email) === false) {
//       errors.email = "Enter Valid Email Address";
//     }

//     if (password.trim() === '') {
//       errors.password = 'Password is required';
//     }

//     setFormErrors(errors);

//     if (Object.keys(errors).length === 0) {
//       setShowLoading(true);
//       AuthService.Login(email, password, logInfo)
//         .then((response) => {
//           console.log(response)
//           if (response.data.responseText.startsWith("SUCCESS")) {
//             if (response.data.userModel.uflag === "false") {
//               alert("Your account is not active, Please contact Atmagram")
//             }
//             else {
//               var usrRole = response.data.userModel.role;

//               if (usrRole === "ROLE_ADMIN") {
//                 history.push("/")
//                 // history.push("/admin_page")
//               }
//               // else if (usrRole === "ROLE_TEMPADMIN") {
//               //   history.push("/tempadmin")
//               // }
//               else if (usrRole === "ROLE_VENDOR") {
//                 history.push("/")
//               }
//               // else if (usrRole === "ROLE_PROJECTADMIN") {
//               //   history.push("/projectadmin")
//               // }
//               else if (usrRole === "ROLE_USER" || usrRole === "ROLE_VOLUNTEER" || usrRole === "ROLE_FINANCE") {
//                 history.replace("/")
//               }
//               if (Capacitor.getPlatform() === "web") {
//                 console.log(response.data)
//                 setUFlag(response.data.userModel.uflag)
//                 setToken(response.data.userToken)
//                 setUserData(response.data.userModel.role)
//                 sessionStorage.setItem("token", response.data.userToken);
//                 // sessionStorage.setItem("UserId", response.data.userModel.id);
//                 sessionStorage.setItem("UserId", response.data.userModel.userId);
//                 sessionStorage.setItem("uFlag", response.data.userModel.uflag);
//                 sessionStorage.setItem("UserData", response.data.userModel.role);
//                 sessionStorage.setItem("Email", response.data.userModel.email);
//                 sessionStorage.setItem("Phone", response.data.userModel.mobileNumber);
//                 if (response.data.userModel.address !== null) {
//                   sessionStorage.setItem("Address", response.data.userModel.address);
//                 }
//                 if (response.data.userModel.firstName !== null) {
//                   sessionStorage.setItem("Name", response.data.userModel.firstName);
//                 }
//                 if (response.data.userModel.lastName !== null) {
//                   sessionStorage.setItem("lastName", response.data.userModel.lastName);
//                 }
//               }
//               else {
//                 if (response.data.userModel.role === "ROLE_TEMPADMIN" || response.data.userModel.role === "ROLE_VENDOR" || response.data.userModel.role === "ROLE_USER") {
//                   sessionStorage.setItem("token", response.data.userToken);
//                   sessionStorage.setItem("UserId", response.data.userModel.id);
//                   sessionStorage.setItem("UserData", response.data.userModel.role);
//                   sessionStorage.setItem("uFlag", response.data.userModel.uflag);
//                   sessionStorage.setItem("Email", response.data.userModel.email);
//                   setUFlag(response.data.userModel.uflag)
//                   setToken(response.data.userToken)
//                   setUserData(response.data.userModel.role)
//                   sessionStorage.setItem("Phone", response.data.userModel.mobileNumber);
//                   if (response.data.userModel.address !== null) {
//                     sessionStorage.setItem("Address", response.data.userModel.address);
//                   }
//                   if (response.data.userModel.firstName !== null) {
//                     sessionStorage.setItem("Name", response.data.userModel.firstName);
//                   }
//                   if (response.data.userModel.lastName !== null) {
//                     sessionStorage.setItem("lastName", response.data.userModel.lastName);
//                   }
//                   // alert("Login Successful");
//                   console.log(response.data.userModel.role);
//                   //history.push("/home");
//                   //window.location.reload();
//                 } else {
//                   alert("User Not Authorized For Mobile App. Please visit Web Application")
//                 }
//               }
//               var usrToken = response.data.userToken;

//               if (token != null && token != undefined && token != "") {
//                 Authservice.VerifyMobileChange(token, usrToken).then((response) => {
//                   if (response.data.startsWith("SUCCESS")) {
//                     alert(response.data.split('SUCCESS:')[1]);
//                     token = null;

//                     history.push("/profile")
//                     return;

//                   } else {
//                     alert(response.data.split('ERROR:')[1]);
//                     token = null;

//                     history.replace("/")
//                     return;


//                   }
//                   console.log(response + "mobRes")
//                 })
//                   .catch((error) => {
//                     console.log(error + "mobErr")
//                   });
//               } else {
//                 // if (Capacitor.getPlatform() === "web") {
//                 // window.location.reload();
//                 // } else {
//                 //   history.goBack();

//                 // }

//               }
//             }
//           } else {
//             alert(response.data.responseText.split("ERROR:")[1]);
//           }
//           setShowLoading(false);
//         })
//         .catch((error) => {
//           console.log(error);
//           setShowLoading(false);
//           // alert("Something went wrong, please try again later.");
//         });
//     }
//   };

//   const Validation = (label: any) => {

//     if (label === "email") {
//       if (email.trim() === '') {
//         setFormErrors((prev: any) => {
//           return { ...prev, email: 'Email is required' }
//         })
//       }
//       else if (validator.isEmail(email) === false) {
//         setFormErrors((prev: any) => {
//           return { ...prev, email: "Enter Valid Email Address" }
//         })
//       }
//       else {
//         setFormErrors((prev: any) => {
//           return { ...prev, email: "" }
//         })
//       }
//     }

//     if (label === "password") {
//       if (password.trim() === '') {
//         setFormErrors((prev: any) => {
//           return { ...prev, password: 'Password is required' }
//         })
//         // errors.password = 'Password is required';
//       }
//       else {
//         setFormErrors((prev: any) => {
//           return { ...prev, password: "" }
//         })
//       }
//     }

//     if (label === "phone") {
//       if (phone === undefined || phone === "") {
//         setFormErrors((prev: any) => {
//           return { ...prev, phone: "Mobile Number is required" }
//         })
//       } else if (!isValidPhoneNumber) {
//         setFormErrors((prev: any) => {
//           return { ...prev, phone: "Enter valid Mobile Number" }
//         })
//       }
//       else {
//         setFormErrors((prev: any) => {
//           return { ...prev, phone: "" }
//         })
//       }
//     }

//     if (label === "otp") {
//       if (otp === undefined || otp === "" || otp == null) {
//         setFormErrors((prev: any) => {
//           return { ...prev, otp: "Enter OTP" }
//         })
//       }
//       else {
//         setFormErrors((prev: any) => {
//           return { ...prev, otp: "" }
//         })
//       }
//     }

//     // const error = Validation(label,value);
//     // setFormErrors((prevErrors) => ({ ...prevErrors, [label.toLowerCase()]: error }));
//   }
//   const ChangeValidation = (label: any, e: any) => {

//     if (label === "email") {
//       const email = e.target.value;
//       if (email.trim() === '') {
//         setFormErrors((prev: any) => {
//           return { ...prev, email: 'Email is required' }
//         })
//       }
//       else if (validator.isEmail(email) === false) {
//         setFormErrors((prev: any) => {
//           return { ...prev, email: "Enter Valid Email Address" }
//         })
//       }
//       else {
//         setFormErrors((prev: any) => {
//           return { ...prev, email: "" }
//         })
//       }
//     }

//     if (label === "password") {
//       const password = e.target.value;
//       if (password.trim() === '') {
//         setFormErrors((prev: any) => {
//           return { ...prev, password: 'Password is required' }
//         })
//         // errors.password = 'Password is required';
//       }
//       else {
//         setFormErrors((prev: any) => {
//           return { ...prev, password: "" }
//         })
//       }
//     }

//     if (label === "phone") {
//       const phone = e;

//       let valid: any = false
//       try {
//         const phoneNumberObject: any = parsePhoneNumberFromString(e);
//         valid = phoneNumberObject ? phoneNumberObject.isValid() : false;
//       } catch (error) {
//         valid = false;
//         console.log(error)
//       }

//       if (phone === undefined || phone === "") {
//         setFormErrors((prev: any) => {
//           return { ...prev, phone: "Mobile Number is required" }
//         })
//       } else if (!valid) {
//         setFormErrors((prev: any) => {
//           return { ...prev, phone: "Enter valid Mobile Number" }
//         })
//       }
//       else {
//         setFormErrors((prev: any) => {
//           return { ...prev, phone: "" }
//         })
//       }
//     }

//     if (label === "otp") {
//       const otp = e.target.value;
//       if (otp === undefined || otp === "" || otp == null) {
//         setFormErrors((prev: any) => {
//           return { ...prev, otp: "Enter OTP" }
//         })
//       }
//       else {
//         setFormErrors((prev: any) => {
//           return { ...prev, otp: "" }
//         })
//       }
//     }

//     // const error = Validation(label,value);
//     // setFormErrors((prevErrors) => ({ ...prevErrors, [label.toLowerCase()]: error }));
//   }

//   const SearchF = (value: any) => {
//     if (value == "Enter") {
//       Submit()
//     }
//   }
//   const phoneLogin = () => {
//     setIndex(1)

//   }
//   const emailLogin = () => {
//     setIndex(0)
//   }
//   const goBack = () => {
//     setShowOtp(false)
//   }
//   // }
//   //   const signIn  = ()=> {

//   //     const result =  Plugins.GoogleAuth.signIn();
//   //     console.info('result', result);
//   //     if (result) {
//   //       // history.push({
//   //       //   pathname: '/home',
//   //       //   state: { name: result.name || result.displayName, image: result.imageUrl, email: result.email }
//   //       // });
//   //       console.log("name"+ result.name+"displayName"+result.displayName)
//   //     }

//   // googleLogin();

//   //   }

//   const handleGoogleSignUp = async () => {
//     try {
//       const result = await signInWithPopup(auth, provider);
//       console.log("User Info:", result.user);
//       alert(`Welcome, ${result.user.displayName}`);
//     } catch (error) {
//       console.error("Google Sign-In Error:", error);
//     }
//   };


//   return (
//     <IonPage>
//       <IonContent>
//         <div className="head_login">
//           <HeadFoot User={"login"} Role="Role" Name="Home,Login" />
//         </div>


//         <IonLoading message="Loading..." spinner={null}
//           isOpen={showLoading}
//         // onDidDismiss={() => setShowLoading(false)}
//         // duration={5000}
//         />
//         {/* <UserHead Role={userdata[0]} User="login" /> */}
//         <Modal show={forpassmodal} className="profile-modal">
//           <ModalHeader className="profilenodal-Header">
//             <h2 className="profileModal-title">Forgot Password</h2>
//             <div>

//               <IonIcon src={close} className="close_icon" onClick={() => setforpassmodal(false)} />
//             </div>
//           </ModalHeader>
//           <Modal.Body>

//             <IonRow>
//               <IonCol size="12">
//                 <IonLabel className="form-labels">
//                   Email
//                 </IonLabel>
//                 <IonInput
//                   type="email"
//                   value={passemail}
//                   required
//                   placeholder="Enter registered email-id"
//                   onIonChange={(e) => setPassemail(e.detail.value!)}
//                   ref={inputRef}
//                   onBlur={handleBlur}
//                   className="profile-inputs"
//                   aria-errormessage="email-error"
//                 ></IonInput>
//                 {errorMessage && <span className="alert_input_bottom " ref={errorMessageRef} id="email-error" color="danger">{errorMessage}</span>}
//               </IonCol>
//             </IonRow>
//             <div className={passemail.length == 0 || validator.isEmail(passemail) === false ? "disableCursor" : ""} style={{ width: "fit-content" }}>
//               <IonButton disabled={passemail.length == 0 || validator.isEmail(passemail) === false} onClick={() => ForgetSubmit()}>
//                 <span className="button_padding">Submit</span>
//               </IonButton>
//             </div>
//           </Modal.Body>
//         </Modal>
//         <Modal show={alertmodal} className="login_alert_modal" centered>
//           <Modal.Body>
//             <div style={{ textAlign: "center" }}>
//               <h5 className="login_alert_title">Atmagram</h5>
//             </div>
//             <div style={{ textAlign: "center" }}>
//               <IonText>{alertdata}</IonText>
//             </div>
//             <div style={{ textAlign: "right", paddingTop: "15px" }}>
//               <IonText style={{ cursor: "pointer" }} onClick={() => alertmodalclose()}>OK</IonText>
//             </div>
//           </Modal.Body>
//         </Modal>
//         <IonRow className="page_container">
//           <IonCol className="img_container" sizeLg="7.5" sizeMd="0" sizeXl="7.5" sizeSm="0" size="7.5" sizeXs="0" >
//             <div className="tool_img" >
//               <div className="logo_login">
//                 <Link to="/" style={{ textDecoration: "none" }}>
//                   <IonImg className="logo_class" src={logo} ></IonImg>
//                 </Link></div>
//             </div>
//           </IonCol>
//           <IonCol sizeLg="4.5" sizeMd="12" sizeXl="4.5" sizeSm="12" size="4.5" sizeXs="12">
//             <div className="register_login_title">
//               <Link to="/" >
//                 <IonIcon src={home} className="home_icon">
//                 </IonIcon>
//               </Link>
//                               <IonIcon src={downloadOutline} className="download_icon" onClick={handleInstallClick}>
//               </IonIcon>
//             </div>
//             <div className="login_top">
//               {index == 0 ?
//                 <div className="login_container">
//                   <form onSubmit={handleSubmit(Submit)} onKeyPress={e => SearchF(e.key)}>
//                     <div>
//                       <span className="login_head">Login</span>
//                       <IonRow  >

//                         <IonCol size="11" size-lg="7" className="email_container">
//                           <div>

//                             <IonLabel className="label_align">
//                               E-mail <span style={{ color: "red" }}>*</span>
//                             </IonLabel>

//                             <IonInput className="select_user"
//                               type="text"
//                               style={{ textTransform: "none" }}
//                               value={email} placeholder="Enter Email-id"
//                               onIonChange={(e) => {
//                                 setEmail(e.detail.value!);
//                                 ChangeValidation("email", e)
//                               }}
//                               onBlur={(e) => Validation("email")}
//                             // required
//                             ></IonInput>
//                             {/* <span slot="error">Name is required</span> */}

//                           </div>
//                           {formErrors.email && <span className="alert_input_bottom ">{formErrors.email}</span>}
//                         </IonCol>
//                       </IonRow>
//                       <IonRow >

//                         <IonCol size="11" className="pass_container" style={{ position: "relative" }}>
//                           <div style={{ width: "100%" }}>
//                             <IonLabel className="label_align">
//                               Password <span style={{ color: "red" }}>*</span>
//                             </IonLabel>
//                             <IonInput
//                               type={showPassword ? "text" : "password"}
//                               style={{ textTransform: "none" }}
//                               clearOnEdit={false} className="select_user" placeholder="Enter password"
//                               onIonChange={(e) => { setPassword(e.detail.value!); ChangeValidation("password", e) }}
//                               // required
//                               onBlur={(e) => Validation("password")}
//                             ></IonInput>
//                             <div
//                               className="eye_icon"
//                               onClick={() => setShowPassword(!showPassword)}
//                               style={{
//                                 position: "absolute",
//                                 right: "0px",
//                                 top: "50%",
//                                 cursor: "pointer",
//                                 zIndex: 1,
//                               }}
//                             >
//                               <IonIcon icon={showPassword ? eyeOff : eye} />
//                             </div>
//                           </div>
//                           {formErrors.password && <span className="alert_input_bottom ">{formErrors.password}</span>}
//                         </IonCol>
//                       </IonRow>
//                       <IonRow>
//                         <IonCol size="6" size-lg="6" className="pass_container" >
//                           <div>
//                             <Link to="/signup" className="forgot_pass_css">Don't have account?</Link>
//                           </div>
//                         </IonCol>
//                         <IonCol size="6" size-lg="6" className="pass_container" >
//                           <div style={{ textAlign: "right" }}>
//                             <IonText onClick={() => setforpassmodal(true)} className="forgot_pass_css">Forgot Password?</IonText>
//                           </div>
//                         </IonCol>
//                       </IonRow>
//                       <IonRow className="login_btn_container">
//                         <div className={email.length === 0 || password.length === 0 ? "disableCursor" : ""}>
//                           <IonButton
//                             type="submit"
//                             disabled={email.length === 0 || password.length === 0}
//                           >
//                             <span className="button_padding"> Login</span>

//                           </IonButton>
//                         </div>
//                       </IonRow>
//                       <div className="center or_text_container">
//                         <p>
//                           or
//                         </p>
//                       </div>
//                     </div>
//                   </form>
//                   <IonRow className="login_btn_container">
//                     <IonButton onClick={phoneLogin}>
//                       <span className="button_padding">  Login With Phone</span>
//                     </IonButton>



//                     {/* <button
//                       onClick={handleInstallClick}
//                       className="install-btn"
//                       style={{
//                         height: "50px",
//                         backgroundColor: '#576f9f',
//                         padding: "15px 22px 15px 22px",
//                         fontSize: 14,
//                         color: '#ffffff',
//                         fontFamily: 'Roboto, sans-serif',
//                         fontWeight: 'bold', // or 'bold'
//                         boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)', // lighter, smaller shadow      letterSpacing: 2,
//                         borderRadius: 30,
//                         letterSpacing: 1.5
//                       }}
//                     >
//                       Add to Home Screen
//                     </button> */}

//                   </IonRow>
//                   {/* <div style={{ width: "100%", justifyContent: "center", display: "flex", marginTop: "20px" }}>
//                     <div className="google-signup" onClick={handleGoogleSignUp}>
//                       <IonIcon icon={logoGoogle} className="google-icon" />
//                       <span>Sign Up with Google</span>
//                     </div>
//                   </div> */}


//                 </div>

//                 : <div className="login_withmobile_container">
//                   <span className="login_head">Login</span>
//                   {!showOtp ? <>
//                     <IonRow>
//                       <IonCol size="11" size-lg="7" className="email_container">
//                         <div>
//                           <IonLabel className="label_align">
//                             Mobile Number <span style={{ color: "red" }}>*</span>
//                           </IonLabel>
//                           <PhoneInput
//                             international
//                             defaultCountry="IN"
//                             value={phone}
//                             className="select_user"
//                             ref={phoneInputRef}
//                             // flags=false
//                             onBlur={(e) => Validation("phone")}
//                             onChange={(value: any) => { moveCursorToEnd(value); ChangeValidation("phone", value) }}
//                           />

//                         </div>
//                         {formErrors.phone && <span className="alert_input_bottom ">{formErrors.phone}</span>}
//                       </IonCol>
//                     </IonRow>

//                     <IonRow>
//                       <IonCol size="11" size-lg="7" className="pass_container">
//                         <div id="recaptcha-container"></div>
//                       </IonCol>
//                     </IonRow>
//                     <IonRow className="login_btn_container">
//                       <div className={phone === undefined || phone === "" || !isValidPhoneNumber ? "cursor_block" : ""}>
//                         <IonButton
//                           onClick={checkMobile}
//                           disabled={phone === undefined || phone === "" || !isValidPhoneNumber}
//                         >
//                           <span className="button_padding"> Get OTP</span>
//                         </IonButton>
//                       </div>
//                     </IonRow>
//                   </> : <></>}

//                   {showOtp ?
//                     <>
//                       <IonRow>
//                         <IonCol size="11" size-lg="7" className="email_container">

//                           <IonLabel className="label_align">
//                             Enter OTP <span style={{ color: "red" }}>*</span>
//                           </IonLabel>
//                           <IonInput className="select_user"
//                             onBlur={(e) => Validation("otp")}
//                             onIonChange={(e) => { setOtp(e.detail.value!); ChangeValidation("otp", e) }}
//                             required
//                           ></IonInput>

//                           {formErrors.otp && <span className="alert_input_bottom ">{formErrors.otp}</span>}
//                         </IonCol>
//                       </IonRow>

//                       <IonRow>
//                         <IonCol size="11" size-lg="7" className="pass_container" >
//                           <span className="go_back_style"
//                             onClick={goBack}
//                           >go back
//                           </span>
//                         </IonCol>
//                       </IonRow>

//                       <IonRow className="login_btn_container">
//                         <IonButton onClick={verifyOTP}>
//                           <span className="button_padding">Verify OTP</span>
//                         </IonButton>
//                       </IonRow>
//                     </> : <></>
//                   }

//                   <div className="center or_text_container"><p>
//                     or</p></div>
//                   <IonRow className="login_btn_container">
//                     <IonButton onClick={emailLogin}>
//                       <span className="button_padding"> Login With Email</span>
//                     </IonButton>
//                   </IonRow>
//                 </div>

//               }


//             </div>

//             {/* {Capacitor.getPlatform() === "web"? */}

//             {/* :<></>}  */}
//           </IonCol>
//         </IonRow>
//         {/* <Foot /> */}
//       </IonContent>
//     </IonPage>
//   );
// };

// export default Tab2;


// import {
//   IonContent,
//   IonPage,
//   IonButton,
//   IonItemDivider,
//   IonRow,
//   IonInput,
//   IonLabel,
//   IonItem,
//   useIonRouter,
//   IonCol,
//   useIonAlert,
//   IonLoading,
//   IonImg,
//   IonText,
//   IonIcon
// } from "@ionic/react";
// import { useForm } from "react-hook-form";
// import { Link, useHistory, useLocation, useParams } from "react-router-dom";
// import { useState, useEffect, useContext, useRef } from "react";
// import "./Home.css";
// import UserHead from "./UserHead";
// import Foot from "./Foot";
// import AuthService from "../Services/auth.service";
// import "./Login.css";
// import { Modal, ModalHeader } from "react-bootstrap";

// // import "@codetrix-studio/capacitor-google-auth";
// // import { Plugins } from '@capacitor/core';

// import { Capacitor } from "@capacitor/core"
// import validator from 'validator'
// import Authservice from "../Services/user.service";
// import CustomSpin from "../components/customSpin";
// import { AppContext } from "../components/AppContext";
// import { auth, provider, signInWithPopup } from "../Services/firebase-config";

// import { PhoneAuthProvider, RecaptchaVerifier, getAuth, signInWithPhoneNumber } from "firebase/auth";
// import PhoneInput from 'react-phone-number-input';
// import 'react-phone-number-input/style.css'
// import { parsePhoneNumberFromString } from 'libphonenumber-js';
// import { closeicon, logo } from "../theme/imagePath";
// import { close, eye, eyeOff, home,downloadOutline, logoGoogle } from "ionicons/icons";
// import HeadFoot from "./Head";
// import { fetchUserDetails } from "../components/userInformation";


// const Tab2: React.FC = () => {
//   const history = useHistory();
//   const params: any = useParams()
//   const { handleSubmit } = useForm({
//     mode: "onTouched",
//     reValidateMode: "onChange",
//   });
//   const [email, setEmail] = useState("");
//   const [passemail, setPassemail] = useState("");

//   const router = useIonRouter();
//   const [userid] = useState(sessionStorage.getItem("UserId"));
//   const [usertoken] = useState(sessionStorage.getItem("token"));
//   // var userdata: any = sessionStorage.getItem("UserData");
//   const { userdata } = useContext(AppContext)!;
//   const [showLoading, setShowLoading] = useState(false);
//   const [forpassmodal, setforpassmodal] = useState(false)
//   const inputRef = useRef<HTMLIonInputElement>(null);
//   const errorMessageRef = useRef<HTMLIonTextElement>(null);
//   const [errorMessage, setErrorMessage]: any = useState<string>('');
//   const [msg, setMsg] = useState("");

//   const [password, setPassword] = useState("");
//   const mailpat = /[a-zA-Z0-9]+[\.]?([a-zA-Z0-9]+)?[\@][a-z]{3,9}[\.][a-z]{2,5}/g;
//   const local: any = useLocation()
//   const [path, setPath] = useState(false)
//   var token: any = params.token;
//   console.log("logintkn" + token)
//   const { setUFlag } = useContext(AppContext)!;
//   const { setToken } = useContext(AppContext)!;
//   const { setUserData } = useContext(AppContext)!;
//   const [phone, setPhone] = useState("");
//   const [otp, setOtp] = useState("");
//   const [confirmationResult, setconfirmationResult]: any = useState();
//   const [index, setIndex]: any = useState(0);
//   const [showOtp, setShowOtp]: any = useState(false);
//   const widthSize: any = window.innerWidth;
//   const [isValidPhoneNumber, setIsValidPhoneNumber] = useState(false);
//   var load: any = false;

//   const [logInfo, setLogInfo]: any = useState("")
//   const [showPassword, setShowPassword] = useState(false);

//   //added by me

//   // const [deferredPrompt, setDeferredPrompt] = useState<any>(null);
//   // const [showInstallButton, setShowInstallButton] = useState(false);

//   // useEffect(() => {
//   //   const handleBeforeInstallPrompt = (e: any) => {
//   //     e.preventDefault();
//   //     setDeferredPrompt(e);
//   //     setShowInstallButton(true);
//   //   };

//   //   window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

//   //   return () => {
//   //     window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
//   //   };
//   // }, []);


//   // const handleInstallClick = () => {
//   //   if (!deferredPrompt) return;

//   //   deferredPrompt.prompt();
//   //   deferredPrompt.userChoice.then((choiceResult: any) => {
//   //     if (choiceResult.outcome === 'accepted') {
//   //       console.log('✅ User accepted the install prompt');
//   //     } else {
//   //       console.log('❌ User dismissed the install prompt');
//   //     }
//   //     setDeferredPrompt(null);
//   //     setShowInstallButton(false);
//   //   });
//   // };

//   const [deferredPrompt, setDeferredPrompt] = useState<any>(null);
// const [showInstallButton, setShowInstallButton] = useState(false);
// const [isIos, setIsIos] = useState(false);
// const [isInStandaloneMode, setIsInStandaloneMode] = useState(false);

// useEffect(() => {
//   const userAgent = window.navigator.userAgent.toLowerCase();
//   const isIosDevice = /iphone|ipad|ipod/.test(userAgent);
//   const isStandalone = ('standalone' in window.navigator) && (window.navigator as any).standalone;

//   setIsIos(isIosDevice);
//   setIsInStandaloneMode(isStandalone);

//   const handleBeforeInstallPrompt = (e: any) => {
//     e.preventDefault();
//     setDeferredPrompt(e);
//     setShowInstallButton(true);
//   };

//   window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

//   return () => {
//     window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
//   };
// }, []);
// const handleInstallClick = async () => {
//   if (!deferredPrompt) return;

//   deferredPrompt.prompt();
//   const choiceResult = await deferredPrompt.userChoice;

//   if (choiceResult.outcome === 'accepted') {
//     console.log('✅ User accepted the install prompt');
//   } else {
//     console.log('❌ User dismissed the install prompt');
//   }

//   setDeferredPrompt(null);
//   setShowInstallButton(false);
// };

//   //added by me


//   const [formErrors, setFormErrors] = useState({
//     email: '',
//     password: '',
//     phone: "",
//     otp: ""
//   });
//   const [alert] = useIonAlert();
//   const phoneInputRef = useRef(null)
//   const moveCursorToEnd = (value: any) => {
//     const input: any = phoneInputRef.current;
//     if (widthSize <= 500) {
//       if (input) {
//         setTimeout(() => {
//           input.focus();
//           input.setSelectionRange(input.value.length, input.value.length);
//         }, 0);
//       }
//     }
//     try {
//       const phoneNumberObject: any = parsePhoneNumberFromString(value);
//       setIsValidPhoneNumber(phoneNumberObject ? phoneNumberObject.isValid() : false);
//     } catch (error) {
//       setIsValidPhoneNumber(false);
//       console.log(error)
//     }
//     setPhone(value)
//   };
//   const verifyOTP = () => {
//     // var credential = PhoneAuthProvider.credential(confirmationResult.verificationId, otp);
//     // console.log(credential);
//     const errors: any = {};
//     if (otp === undefined || otp === "" || otp == null) {
//       errors.otp = "Enter OTP"
//     }
//     setFormErrors(errors);
//     console.log(formErrors)
//     if (Object.keys(errors).length === 0) {
//       confirmationResult.confirm(otp).then((result: any) => {
//         // User signed in successfully.
//         const user = result.user;
//         console.log(result);
//         setShowLoading(true);
//         AuthService.mobileLogin(phone)
//           .then((response) => {
//             if (response.data.responseText.startsWith("SUCCESS")) {
//               if (response.data.userModel.uflag === "false") {
//                 alert("Your account is not active, Please contact Atmagram")
//               }
//               else {
//                 console.log(response.data)
//                 sessionStorage.setItem("token", response.data.userToken);
//                 sessionStorage.setItem("UserId", response.data.userModel.userId);
//                 sessionStorage.setItem("uFlag", response.data.userModel.uflag);
//                 sessionStorage.setItem("UserData", response.data.userModel.role);
//                 sessionStorage.setItem("Email", response.data.userModel.email);
//                 sessionStorage.setItem("Phone", response.data.userModel.mobileNumber);
//                 setUFlag(response.data.userModel.uflag)
//                 setToken(response.data.userToken)
//                 setUserData(response.data.userModel.role)
//                 if (response.data.userModel.address !== null) {
//                   sessionStorage.setItem("Address", response.data.userModel.address);
//                 }
//                 if (response.data.userModel.firstName !== null) {
//                   sessionStorage.setItem("Name", response.data.userModel.firstName);
//                 }
//                 if (response.data.userModel.lastName !== null) {
//                   sessionStorage.setItem("lastName", response.data.userModel.lastName);
//                 }
//                 var usrRole = response.data.userModel.role;
//                 history.replace("/")

//               }
//               var usrToken = response.data.userToken;
//               if (token != null && token != undefined && token != "") {
//                 Authservice.VerifyMobileChange(token, usrToken).then((response) => {
//                   if (response.data.startsWith("SUCCESS")) {
//                     alert(response.data.split('SUCCESS:')[1]);
//                     token = null;
//                     history.push("/profile")
//                     return;
//                   } else {
//                     alert(response.data.split('ERROR:')[1]);
//                     token = null;
//                     history.replace("/")
//                     return;
//                   }
//                   console.log(response + "mobRes")
//                 })
//                   .catch((error) => {
//                     console.log(error + "mobErr")
//                   });
//               } else {
//                 // if (Capacitor.getPlatform() === "web") {
//                 //   window.location.reload();
//                 // } else {
//                 //   history.goBack();

//                 // }


//               }


//             } else {
//               alert(response.data.responseText.split("ERROR:")[1]);
//             }
//             setShowLoading(false);
//           })
//           .catch((error) => {
//             console.log(error);
//             setShowLoading(false);
//           });

//         // ...
//       }).catch((err: any) => {
//         // User couldn't sign in (bad verification code?)
//         console.log(err.error);
//         alert("Not a valid verification code or Code expired, please try again")


//         // if(error.error.message=='SESSION_EXPIRED'){
//         //   alert("OTP expired");
//         // }else{

//         // }
//         // ...
//       });
//     }


//   }
//   const checkMobile = () => {
//     const errors: any = {};
//     if (phone === undefined || phone === "") {
//       errors.phone = "Mobile Number is required"
//     } else if (!isValidPhoneNumber) {
//       errors.phone = "Enter valid Mobile Number"
//     }
//     setFormErrors(errors);
//     console.log(formErrors)
//     if (Object.keys(errors).length === 0) {
//       setShowLoading(true);
//       AuthService.validMob(phone).then((res) => {
//         setShowLoading(false);
//         if (res.data) {
//           getOTP();
//         } else {
//           alert("Please complete registration. Then only you can login with Atmagram")
//         }

//       }).catch((error) => {
//         console.log(error);
//         setShowLoading(false);
//       });
//     }
//   }

//   const getOTP = () => {
//     let verify = new RecaptchaVerifier('recaptcha-container', {
//       'size': 'normal',
//       'callback': (response: any) => {
//         // reCAPTCHA solved, allow signInWithPhoneNumber.
//         // ...
//       },
//       'expired-callback': () => {
//         // Response expired. Ask user to solve reCAPTCHA again.
//         // ...
//         alert("Response expired. Please solve reCAPTCHA again")
//       }
//     }, auth);

//     signInWithPhoneNumber(auth, phone, verify)
//       .then((confirmationResult) => {
//         // SMS sent. Prompt user to type the code from the message, then sign the
//         // user in with confirmationResult.confirm(code).
//         console.log(confirmationResult);
//         setShowOtp(true)
//         setconfirmationResult(confirmationResult)
//         // ...
//       }).catch((error) => {
//         // Error; SMS not sent
//         console.log("mob error" + error)
//         alert("Something went wrong, please try again later.")
//         // ...
//       });
      
//   }

//   const fetchDetails = async () => {
//     const details = await fetchUserDetails();
//     console.log(JSON.stringify(details));
//     setLogInfo(JSON.stringify(details));
//   };

//   useEffect(() => {
//     fetchDetails();
//   }, []);

//   useEffect(() => {
//     if (!load) {
//       if (userdata != null) {
//         //history.goForward();
//         // history.replace("/")
//         sessionStorage.clear()
//       }
//       load = true;
//     }

//     console.log(local.state)
//   }, []);

//   const [alertmodal, setAlertmodal] = useState(false)
//   const [alertdata, setAlertdata] = useState("")
//   const ForgetSubmit = () => {
//     setShowLoading(true);
//     AuthService.Forgotpassword(passemail).then((response) => {

//       if (response.data.startsWith("SUCCESS")) {
//         console.log(response.data)
//         var res = response.data.split('SUCCESS:')[1];
//         alertmodalaction(true, "Reset password link sent to your Email Id!")

//         setShowLoading(false);

//       } else {
//         setShowLoading(false);
//         alertmodalaction(true, "Account Not Found")
//       }

//     })
//       .catch((error) => {
//         console.log(error);
//         setShowLoading(false);
//       });
//   };

//   const alertmodalaction = (e: any, data: any) => {
//     setAlertmodal(e)
//     setAlertdata(data)
//   }

//   const alertmodalclose = () => {
//     if (alertdata === "Reset password link sent to your Email Id!") {
//       window.location.reload()
//     }
//     else {
//       setAlertmodal(false)
//       setAlertdata("")
//     }
//   }

//   const handleBlur = () => {
//     const inputValue: any = inputRef.current?.value;
//     const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

//     if (inputValue === "") {
//       setErrorMessage('Please enter a email address');
//       errorMessageRef.current?.setAttribute('aria-errormessage', 'email-error');
//     }
//     else if (!emailPattern.test(inputValue!)) {
//       setErrorMessage('Please enter a valid email address');
//       errorMessageRef.current?.setAttribute('aria-errormessage', 'email-error');
//     } else {
//       setErrorMessage('');
//       errorMessageRef.current?.removeAttribute('aria-errormessage');
//     }
//   };
//   const Submit = () => {
//     const errors: any = {};

//     if (email.trim() === '') {
//       errors.email = 'Email is required';
//     }
//     else if (validator.isEmail(email) === false) {
//       errors.email = "Enter Valid Email Address";
//     }

//     if (password.trim() === '') {
//       errors.password = 'Password is required';
//     }

//     setFormErrors(errors);

//     if (Object.keys(errors).length === 0) {
//       setShowLoading(true);
//       AuthService.Login(email, password, logInfo)
//         .then((response) => {
//           console.log(response)
//           if (response.data.responseText.startsWith("SUCCESS")) {
//             if (response.data.userModel.uflag === "false") {
//               alert("Your account is not active, Please contact Atmagram")
//             }
//             else {
//               var usrRole = response.data.userModel.role;

//               if (usrRole === "ROLE_ADMIN") {
//                 history.push("/")
//                 // history.push("/admin_page")
//               }
//               // else if (usrRole === "ROLE_TEMPADMIN") {
//               //   history.push("/tempadmin")
//               // }
//               else if (usrRole === "ROLE_VENDOR") {
//                 history.push("/")
//               }
//               // else if (usrRole === "ROLE_PROJECTADMIN") {
//               //   history.push("/projectadmin")
//               // }
//               else if (usrRole === "ROLE_USER" || usrRole === "ROLE_VOLUNTEER" || usrRole === "ROLE_FINANCE") {
//                 history.replace("/")
//               }
//               if (Capacitor.getPlatform() === "web") {
//                 console.log(response.data)
//                 setUFlag(response.data.userModel.uflag)
//                 setToken(response.data.userToken)
//                 setUserData(response.data.userModel.role)
//                 sessionStorage.setItem("token", response.data.userToken);
//                 // sessionStorage.setItem("UserId", response.data.userModel.id);
//                 sessionStorage.setItem("UserId", response.data.userModel.userId);
//                 sessionStorage.setItem("uFlag", response.data.userModel.uflag);
//                 sessionStorage.setItem("UserData", response.data.userModel.role);
//                 sessionStorage.setItem("Email", response.data.userModel.email);
//                 sessionStorage.setItem("Phone", response.data.userModel.mobileNumber);
//                 if (response.data.userModel.address !== null) {
//                   sessionStorage.setItem("Address", response.data.userModel.address);
//                 }
//                 if (response.data.userModel.firstName !== null) {
//                   sessionStorage.setItem("Name", response.data.userModel.firstName);
//                 }
//                 if (response.data.userModel.lastName !== null) {
//                   sessionStorage.setItem("lastName", response.data.userModel.lastName);
//                 }
//               }
//               else {
//                 if (response.data.userModel.role === "ROLE_TEMPADMIN" || response.data.userModel.role === "ROLE_VENDOR" || response.data.userModel.role === "ROLE_USER") {
//                   sessionStorage.setItem("token", response.data.userToken);
//                   sessionStorage.setItem("UserId", response.data.userModel.id);
//                   sessionStorage.setItem("UserData", response.data.userModel.role);
//                   sessionStorage.setItem("uFlag", response.data.userModel.uflag);
//                   sessionStorage.setItem("Email", response.data.userModel.email);
//                   setUFlag(response.data.userModel.uflag)
//                   setToken(response.data.userToken)
//                   setUserData(response.data.userModel.role)
//                   sessionStorage.setItem("Phone", response.data.userModel.mobileNumber);
//                   if (response.data.userModel.address !== null) {
//                     sessionStorage.setItem("Address", response.data.userModel.address);
//                   }
//                   if (response.data.userModel.firstName !== null) {
//                     sessionStorage.setItem("Name", response.data.userModel.firstName);
//                   }
//                   if (response.data.userModel.lastName !== null) {
//                     sessionStorage.setItem("lastName", response.data.userModel.lastName);
//                   }
//                   // alert("Login Successful");
//                   console.log(response.data.userModel.role);
//                   //history.push("/home");
//                   //window.location.reload();
//                 } else {
//                   alert("User Not Authorized For Mobile App. Please visit Web Application")
//                 }
//               }
//               var usrToken = response.data.userToken;

//               if (token != null && token != undefined && token != "") {
//                 Authservice.VerifyMobileChange(token, usrToken).then((response) => {
//                   if (response.data.startsWith("SUCCESS")) {
//                     alert(response.data.split('SUCCESS:')[1]);
//                     token = null;

//                     history.push("/profile")
//                     return;

//                   } else {
//                     alert(response.data.split('ERROR:')[1]);
//                     token = null;

//                     history.replace("/")
//                     return;


//                   }
//                   console.log(response + "mobRes")
//                 })
//                   .catch((error) => {
//                     console.log(error + "mobErr")
//                   });
//               } else {
//                 // if (Capacitor.getPlatform() === "web") {
//                 // window.location.reload();
//                 // } else {
//                 //   history.goBack();

//                 // }

//               }
//             }
//           } else {
//             alert(response.data.responseText.split("ERROR:")[1]);
//           }
//           setShowLoading(false);
//         })
//         .catch((error) => {
//           console.log(error);
//           setShowLoading(false);
//           // alert("Something went wrong, please try again later.");
//         });
//     }
//   };

//   const Validation = (label: any) => {

//     if (label === "email") {
//       if (email.trim() === '') {
//         setFormErrors((prev: any) => {
//           return { ...prev, email: 'Email is required' }
//         })
//       }
//       else if (validator.isEmail(email) === false) {
//         setFormErrors((prev: any) => {
//           return { ...prev, email: "Enter Valid Email Address" }
//         })
//       }
//       else {
//         setFormErrors((prev: any) => {
//           return { ...prev, email: "" }
//         })
//       }
//     }

//     if (label === "password") {
//       if (password.trim() === '') {
//         setFormErrors((prev: any) => {
//           return { ...prev, password: 'Password is required' }
//         })
//         // errors.password = 'Password is required';
//       }
//       else {
//         setFormErrors((prev: any) => {
//           return { ...prev, password: "" }
//         })
//       }
//     }

//     if (label === "phone") {
//       if (phone === undefined || phone === "") {
//         setFormErrors((prev: any) => {
//           return { ...prev, phone: "Mobile Number is required" }
//         })
//       } else if (!isValidPhoneNumber) {
//         setFormErrors((prev: any) => {
//           return { ...prev, phone: "Enter valid Mobile Number" }
//         })
//       }
//       else {
//         setFormErrors((prev: any) => {
//           return { ...prev, phone: "" }
//         })
//       }
//     }

//     if (label === "otp") {
//       if (otp === undefined || otp === "" || otp == null) {
//         setFormErrors((prev: any) => {
//           return { ...prev, otp: "Enter OTP" }
//         })
//       }
//       else {
//         setFormErrors((prev: any) => {
//           return { ...prev, otp: "" }
//         })
//       }
//     }

//     // const error = Validation(label,value);
//     // setFormErrors((prevErrors) => ({ ...prevErrors, [label.toLowerCase()]: error }));
//   }
//   const ChangeValidation = (label: any, e: any) => {

//     if (label === "email") {
//       const email = e.target.value;
//       if (email.trim() === '') {
//         setFormErrors((prev: any) => {
//           return { ...prev, email: 'Email is required' }
//         })
//       }
//       else if (validator.isEmail(email) === false) {
//         setFormErrors((prev: any) => {
//           return { ...prev, email: "Enter Valid Email Address" }
//         })
//       }
//       else {
//         setFormErrors((prev: any) => {
//           return { ...prev, email: "" }
//         })
//       }
//     }

//     if (label === "password") {
//       const password = e.target.value;
//       if (password.trim() === '') {
//         setFormErrors((prev: any) => {
//           return { ...prev, password: 'Password is required' }
//         })
//         // errors.password = 'Password is required';
//       }
//       else {
//         setFormErrors((prev: any) => {
//           return { ...prev, password: "" }
//         })
//       }
//     }

//     if (label === "phone") {
//       const phone = e;

//       let valid: any = false
//       try {
//         const phoneNumberObject: any = parsePhoneNumberFromString(e);
//         valid = phoneNumberObject ? phoneNumberObject.isValid() : false;
//       } catch (error) {
//         valid = false;
//         console.log(error)
//       }

//       if (phone === undefined || phone === "") {
//         setFormErrors((prev: any) => {
//           return { ...prev, phone: "Mobile Number is required" }
//         })
//       } else if (!valid) {
//         setFormErrors((prev: any) => {
//           return { ...prev, phone: "Enter valid Mobile Number" }
//         })
//       }
//       else {
//         setFormErrors((prev: any) => {
//           return { ...prev, phone: "" }
//         })
//       }
//     }

//     if (label === "otp") {
//       const otp = e.target.value;
//       if (otp === undefined || otp === "" || otp == null) {
//         setFormErrors((prev: any) => {
//           return { ...prev, otp: "Enter OTP" }
//         })
//       }
//       else {
//         setFormErrors((prev: any) => {
//           return { ...prev, otp: "" }
//         })
//       }
//     }

//     // const error = Validation(label,value);
//     // setFormErrors((prevErrors) => ({ ...prevErrors, [label.toLowerCase()]: error }));
//   }

//   const SearchF = (value: any) => {
//     if (value == "Enter") {
//       Submit()
//     }
//   }
//   const phoneLogin = () => {
//     setIndex(1)

//   }
//   const emailLogin = () => {
//     setIndex(0)
//   }
//   const goBack = () => {
//     setShowOtp(false)
//   }
//   // }
//   //   const signIn  = ()=> {

//   //     const result =  Plugins.GoogleAuth.signIn();
//   //     console.info('result', result);
//   //     if (result) {
//   //       // history.push({
//   //       //   pathname: '/home',
//   //       //   state: { name: result.name || result.displayName, image: result.imageUrl, email: result.email }
//   //       // });
//   //       console.log("name"+ result.name+"displayName"+result.displayName)
//   //     }

//   // googleLogin();

//   //   }

//   const handleGoogleSignUp = async () => {
//     try {
//       const result = await signInWithPopup(auth, provider);
//       console.log("User Info:", result.user);
//       alert(`Welcome, ${result.user.displayName}`);
//     } catch (error) {
//       console.error("Google Sign-In Error:", error);
//     }
//   };


//   return (
//     <IonPage>
//       <IonContent>
//         <div className="head_login">
//           <HeadFoot User={"login"} Role="Role" Name="Home,Login" />
//         </div>


//         <IonLoading message="Loading..." spinner={null}
//           isOpen={showLoading}
//         // onDidDismiss={() => setShowLoading(false)}
//         // duration={5000}
//         />
//         {/* <UserHead Role={userdata[0]} User="login" /> */}
//         <Modal show={forpassmodal} className="profile-modal">
//           <ModalHeader className="profilenodal-Header">
//             <h2 className="profileModal-title">Forgot Password</h2>
//             <div>

//               <IonIcon src={close} className="close_icon" onClick={() => setforpassmodal(false)} />
//             </div>
//           </ModalHeader>
//           <Modal.Body>

//             <IonRow>
//               <IonCol size="12">
//                 <IonLabel className="form-labels">
//                   Email
//                 </IonLabel>
//                 <IonInput
//                   type="email"
//                   value={passemail}
//                   required
//                   placeholder="Enter registered email-id"
//                   onIonChange={(e) => setPassemail(e.detail.value!)}
//                   ref={inputRef}
//                   onBlur={handleBlur}
//                   className="profile-inputs"
//                   aria-errormessage="email-error"
//                 ></IonInput>
//                 {errorMessage && <span className="alert_input_bottom " ref={errorMessageRef} id="email-error" color="danger">{errorMessage}</span>}
//               </IonCol>
//             </IonRow>
//             <div className={passemail.length == 0 || validator.isEmail(passemail) === false ? "disableCursor" : ""} style={{ width: "fit-content" }}>
//               <IonButton disabled={passemail.length == 0 || validator.isEmail(passemail) === false} onClick={() => ForgetSubmit()}>
//                 <span className="button_padding">Submit</span>
//               </IonButton>
//             </div>
//           </Modal.Body>
//         </Modal>
//         <Modal show={alertmodal} className="login_alert_modal" centered>
//           <Modal.Body>
//             <div style={{ textAlign: "center" }}>
//               <h5 className="login_alert_title">Atmagram</h5>
//             </div>
//             <div style={{ textAlign: "center" }}>
//               <IonText>{alertdata}</IonText>
//             </div>
//             <div style={{ textAlign: "right", paddingTop: "15px" }}>
//               <IonText style={{ cursor: "pointer" }} onClick={() => alertmodalclose()}>OK</IonText>
//             </div>
//           </Modal.Body>
//         </Modal>
//         <IonRow className="page_container">
//           <IonCol className="img_container" sizeLg="7.5" sizeMd="0" sizeXl="7.5" sizeSm="0" size="7.5" sizeXs="0" >
//             <div className="tool_img" >
//               <div className="logo_login">
//                 <Link to="/" style={{ textDecoration: "none" }}>
//                   <IonImg className="logo_class" src={logo} ></IonImg>
//                 </Link></div>
//             </div>
//           </IonCol>
//           <IonCol sizeLg="4.5" sizeMd="12" sizeXl="4.5" sizeSm="12" size="4.5" sizeXs="12">
//             <div className="register_login_title">
//                 <IonIcon src={downloadOutline} className="download_icon"
//                 onClick={() => handleInstallClick()}>
//                 </IonIcon>

//                 {/* Show only if install is available or iOS guidance needed */}
// {(showInstallButton || (isIos && !isInStandaloneMode)) && (
//   <IonIcon
//     icon={downloadOutline}
//     className="download_icon"
//     onClick={() => {
//       if (isIos) {
//         alert("To install the app, tap the 'Share' icon in Safari and choose 'Add to Home Screen'.");
//       } else {
//         handleInstallClick();
//       }
//     }}
//   />
// )}

//               <Link to="/" >
//                 <IonIcon src={home} className="home_icon">
//                 </IonIcon>
//               </Link>
//             </div>
//             <div className="login_top">
//               {index == 0 ?
//                 <div className="login_container">
//                   <form onSubmit={handleSubmit(Submit)} onKeyPress={e => SearchF(e.key)}>
//                     <div>
//                       <span className="login_head">Login</span>
//                       <IonRow  >

//                         <IonCol size="11" size-lg="7" className="email_container">
//                           <div>

//                             <IonLabel className="label_align">
//                               E-mail <span style={{ color: "red" }}>*</span>
//                             </IonLabel>

//                             <IonInput className="select_user"
//                               type="text"
//                               style={{ textTransform: "none" }}
//                               value={email} placeholder="Enter Email-id"
//                               onIonChange={(e) => {
//                                 setEmail(e.detail.value!);
//                                 ChangeValidation("email", e)
//                               }}
//                               onBlur={(e) => Validation("email")}
//                             // required
//                             ></IonInput>
//                             {/* <span slot="error">Name is required</span> */}

//                           </div>
//                           {formErrors.email && <span className="alert_input_bottom ">{formErrors.email}</span>}
//                         </IonCol>
//                       </IonRow>
//                       <IonRow >

//                         <IonCol size="11" className="pass_container">
//   <IonLabel className="label_align">
//     Password <span style={{ color: "red" }}>*</span>
//   </IonLabel>

//   <div
//     style={{
//       position: "relative",
//       display: "flex",
//       alignItems: "center",
//     }}
//   >
//     <IonInput
//       type={showPassword ? "text" : "password"}
//       className="select_user"
//       placeholder="Enter password"
//       style={{
//         textTransform: "none",
//         paddingRight: "40px", // Reserve space for eye icon
//         width: "100%",
//         height: "45px", // Optional: consistent height
//       }}
//       clearOnEdit={false}
//       onIonChange={(e) => {
//         setPassword(e.detail.value!);
//         ChangeValidation("password", e);
//       }}
//       onBlur={(e) => Validation("password")}
//     ></IonInput>

//     <div
//       onClick={() => setShowPassword(!showPassword)}
//       style={{
//         position: "absolute",
//         right: "10px",
//         cursor: "pointer",
//         display: "flex",
//         alignItems: "center",
//         height: "100%",
//       }}
//     >
//       <IonIcon icon={showPassword ? eyeOff : eye} />
//     </div>
//   </div>

//   {formErrors.password && (
//     <span className="alert_input_bottom">{formErrors.password}</span>
//   )}
// </IonCol>

//                       </IonRow>
//                       <IonRow>
//                         <IonCol size="6" size-lg="6" className="pass_container" >
//                           <div>
//                             <Link to="/signup" className="forgot_pass_css">Don't have account?</Link>
//                           </div>
//                         </IonCol>
//                         <IonCol size="6" size-lg="6" className="pass_container" >
//                           <div style={{ textAlign: "right" }}>
//                             <IonText onClick={() => setforpassmodal(true)} className="forgot_pass_css">Forgot Password?</IonText>
//                           </div>
//                         </IonCol>
//                       </IonRow>
//                       <IonRow className="login_btn_container">
//                         <div className={email.length === 0 || password.length === 0 ? "disableCursor" : ""}>
//                           <IonButton
//                             type="submit"
//                             disabled={email.length === 0 || password.length === 0}
//                           >
//                             <span className="button_padding"> Login</span>

//                           </IonButton>
//                         </div>
//                       </IonRow>
//                       <div className="center or_text_container">
//                         <p>
//                           or
//                         </p>
//                       </div>
//                     </div>
//                   </form>
//                   <IonRow className="login_btn_container">
//                     <IonButton onClick={phoneLogin}>
//                       <span className="button_padding">  Login With Phone</span>
//                     </IonButton>



                    

//                   </IonRow>
//                   {/* <div style={{ width: "100%", justifyContent: "center", display: "flex", marginTop: "20px" }}>
//                     <div className="google-signup" onClick={handleGoogleSignUp}>
//                       <IonIcon icon={logoGoogle} className="google-icon" />
//                       <span>Sign Up with Google</span>
//                     </div>
//                   </div> */}


//                 </div>

//                 : <div className="login_withmobile_container">
//                   <span className="login_head">Login</span>
//                   {!showOtp ? <>
//                     <IonRow>
//                       <IonCol size="11" size-lg="7" className="email_container">
//                         <div>
//                           <IonLabel className="label_align">
//                             Mobile Number <span style={{ color: "red" }}>*</span>
//                           </IonLabel>
//                           <PhoneInput
//                             international
//                             defaultCountry="IN"
//                             value={phone}
//                             className="select_user"
//                             ref={phoneInputRef}
//                             // flags=false
//                             onBlur={(e) => Validation("phone")}
//                             onChange={(value: any) => { moveCursorToEnd(value); ChangeValidation("phone", value) }}
//                           />

//                         </div>
//                         {formErrors.phone && <span className="alert_input_bottom ">{formErrors.phone}</span>}
//                       </IonCol>
//                     </IonRow>

//                     <IonRow>
//                       <IonCol size="11" size-lg="7" className="pass_container">
//                         <div id="recaptcha-container"></div>
//                       </IonCol>
//                     </IonRow>
//                     <IonRow className="login_btn_container">
//                       <div className={phone === undefined || phone === "" || !isValidPhoneNumber ? "cursor_block" : ""}>
//                         <IonButton
//                           onClick={checkMobile}
//                           disabled={phone === undefined || phone === "" || !isValidPhoneNumber}
//                         >
//                           <span className="button_padding"> Get OTP</span>
//                         </IonButton>
//                       </div>
//                     </IonRow>
//                   </> : <></>}

//                   {showOtp ?
//                     <>
//                       <IonRow>
//                         <IonCol size="11" size-lg="7" className="email_container">

//                           <IonLabel className="label_align">
//                             Enter OTP <span style={{ color: "red" }}>*</span>
//                           </IonLabel>
//                           <IonInput className="select_user"
//                             onBlur={(e) => Validation("otp")}
//                             onIonChange={(e) => { setOtp(e.detail.value!); ChangeValidation("otp", e) }}
//                             required
//                           ></IonInput>

//                           {formErrors.otp && <span className="alert_input_bottom ">{formErrors.otp}</span>}
//                         </IonCol>
//                       </IonRow>

//                       <IonRow>
//                         <IonCol size="11" size-lg="7" className="pass_container" >
//                           <span className="go_back_style"
//                             onClick={goBack}
//                           >go back
//                           </span>
//                         </IonCol>
//                       </IonRow>

//                       <IonRow className="login_btn_container">
//                         <IonButton onClick={verifyOTP}>
//                           <span className="button_padding">Verify OTP</span>
//                         </IonButton>
//                       </IonRow>
//                     </> : <></>
//                   }

//                   <div className="center or_text_container"><p>
//                     or</p></div>
//                   <IonRow className="login_btn_container">
//                     <IonButton onClick={emailLogin}>
//                       <span className="button_padding"> Login With Email</span>
//                     </IonButton>
//                   </IonRow>
//                 </div>

//               }


//             </div>

//             {/* {Capacitor.getPlatform() === "web"? */}

//             {/* :<></>}  */}
//           </IonCol>
//         </IonRow>
//         {/* <Foot /> */}
//       </IonContent>
//     </IonPage>
//   );
// };

// export default Tab2;

import {
  IonContent,
  IonPage,
  IonButton,
  IonItemDivider,
  IonRow,
  IonInput,
  IonLabel,
  IonItem,
  useIonRouter,
  IonCol,
  useIonAlert,
  IonLoading,
  IonImg,
  IonText,
  IonIcon,
  IonAlert
} from "@ionic/react";
import { useForm } from "react-hook-form";
import { Link, useHistory, useLocation, useParams } from "react-router-dom";
import { useState, useEffect, useContext, useRef } from "react";
import "./Home.css";
import UserHead from "./UserHead";
import Foot from "./Foot";
import AuthService from "../Services/auth.service";
import "./Login.css";
import { Modal, ModalHeader } from "react-bootstrap";

// import "@codetrix-studio/capacitor-google-auth";
// import { Plugins } from '@capacitor/core';

import { Capacitor } from "@capacitor/core"
import validator from 'validator'
import Authservice from "../Services/user.service";
import CustomSpin from "../components/customSpin";
import { AppContext } from "../components/AppContext";
import { auth, provider, signInWithPopup } from "../Services/firebase-config";

import { PhoneAuthProvider, RecaptchaVerifier, getAuth, signInWithPhoneNumber } from "firebase/auth";
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css'
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import { closeicon, logo } from "../theme/imagePath";
import { close, eye, eyeOff, home, linkOutline,logoGoogle } from "ionicons/icons";
import HeadFoot from "./Head";
import { fetchUserDetails } from "../components/userInformation";


interface BeforeInstallPromptEvent extends Event {
  prompt(): Promise<void>;
  userChoice: Promise<{
    outcome: 'accepted' | 'dismissed';
    platform: string;
  }>;
}
 
// Extend Navigator interface for iOS standalone detection
declare global {
  interface Navigator {
    standalone?: boolean;
  }
  interface WindowEventMap {
    beforeinstallprompt: BeforeInstallPromptEvent;
  }
}

const Tab2: React.FC = () => {
  const history = useHistory();
  const params: any = useParams()
  const { handleSubmit } = useForm({
    mode: "onTouched",
    reValidateMode: "onChange",
  });
  const [email, setEmail] = useState("");
  const [passemail, setPassemail] = useState("");

  const router = useIonRouter();
  const [userid] = useState(sessionStorage.getItem("UserId"));
  const [usertoken] = useState(sessionStorage.getItem("token"));
  // var userdata: any = sessionStorage.getItem("UserData");
  const { userdata } = useContext(AppContext)!;
  const [showLoading, setShowLoading] = useState(false);
  const [forpassmodal, setforpassmodal] = useState(false)
  const inputRef = useRef<HTMLIonInputElement>(null);
  const errorMessageRef = useRef<HTMLIonTextElement>(null);
  const [errorMessage, setErrorMessage]: any = useState<string>('');
  const [msg, setMsg] = useState("");

  const [password, setPassword] = useState("");
  const mailpat = /[a-zA-Z0-9]+[\.]?([a-zA-Z0-9]+)?[\@][a-z]{3,9}[\.][a-z]{2,5}/g;
  const local: any = useLocation()
  const [path, setPath] = useState(false)
  var token: any = params.token;
  console.log("logintkn" + token)
  const { setUFlag } = useContext(AppContext)!;
  const { setToken } = useContext(AppContext)!;
  const { setUserData } = useContext(AppContext)!;
  const [phone, setPhone] = useState("");
  const [otp, setOtp] = useState("");
  const [confirmationResult, setconfirmationResult]: any = useState();
  const [index, setIndex]: any = useState(0);
  const [showOtp, setShowOtp]: any = useState(false);
  const widthSize: any = window.innerWidth;
  const [isValidPhoneNumber, setIsValidPhoneNumber] = useState(false);
  var load: any = false;

  const [logInfo, setLogInfo]: any = useState("")
  const [showPassword, setShowPassword] = useState(false);


// const [deferredPrompt, setDeferredPrompt] = useState<any>(null);
// const [showInstallButton, setShowInstallButton] = useState(false);
// const [isIos, setIsIos] = useState(false);
// const [isInStandaloneMode, setIsInStandaloneMode] = useState(false);


// const [showInstallAlert, setShowInstallAlert] = useState(false);
// const [alertMessage, setAlertMessage] = useState("");
// const [alertHeader, setAlertHeader] = useState("");


// useEffect(() => {
//   const userAgent = window.navigator.userAgent.toLowerCase();
//   const isIosDevice = /iphone|ipad|ipod/.test(userAgent);
//   const isStandalone = ('standalone' in window.navigator) && (window.navigator as any).standalone;


//    console.log("📱 isIosDevice:", isIosDevice);
//   console.log("🧭 isStandalone (iOS):", isStandalone);
//   console.log("🖥️ display-mode:", window.matchMedia('(display-mode: standalone)').matches);
//   setIsIos(isIosDevice);
//   setIsInStandaloneMode(isStandalone);

//   const handleBeforeInstallPrompt = (e: any) => {
//     e.preventDefault();
//     setDeferredPrompt(e);
//     setShowInstallButton(true);
//   };

//   window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

//   return () => {
//     window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
//   };
// }, []);
// const handleInstallClick = async () => {
//   if (!deferredPrompt) return;

//   deferredPrompt.prompt();
//   const choiceResult = await deferredPrompt.userChoice;

//   if (choiceResult.outcome === 'accepted') {
//     console.log('✅ User accepted the install prompt');
//   } else {
//     console.log('❌ User dismissed the install prompt');
//   }

//   setDeferredPrompt(null);
//   setShowInstallButton(false);
// };
 
const [deferredPrompt, setDeferredPrompt] = useState<BeforeInstallPromptEvent | null>(null);
const [showInstallButton, setShowInstallButton] = useState(false);
const [isIos, setIsIos] = useState(false);
const [isInStandaloneMode, setIsInStandaloneMode] = useState(false);
const [showInstallAlert, setShowInstallAlert] = useState(false);
const [alertMessage, setAlertMessage] = useState("");
const [alertHeader, setAlertHeader] = useState("");
 
// Add this useEffect for PWA detection (alongside your existing useEffects)
useEffect(() => {
  const userAgent = window.navigator.userAgent.toLowerCase();
  const isIosDevice = /iphone|ipad|ipod/.test(userAgent);
 
  // Better detection for standalone mode
  const isStandalone =
    ('standalone' in window.navigator && window.navigator.standalone) ||
    window.matchMedia('(display-mode: standalone)').matches ||
    window.matchMedia('(display-mode: fullscreen)').matches;
 
  console.log("📱 User Agent:", userAgent);
  console.log("📱 isIosDevice:", isIosDevice);
  console.log("🧭 isStandalone:", isStandalone);
  console.log("🖥️ display-mode standalone:", window.matchMedia('(display-mode: standalone)').matches);
 
  setIsIos(isIosDevice);
  setIsInStandaloneMode(isStandalone);
 
  // Always show the install button
  setShowInstallButton(true);
 
  const handleBeforeInstallPrompt = (e: BeforeInstallPromptEvent) => {
    console.log("🎯 beforeinstallprompt event fired");
    e.preventDefault();
    setDeferredPrompt(e);
    setShowInstallButton(true);
  };
 
  const handleAppInstalled = () => {
    console.log("✅ PWA was installed");
    // Keep the button visible even after installation
    // setShowInstallButton(false);
    setDeferredPrompt(null);
  };
 
  window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
  window.addEventListener('appinstalled', handleAppInstalled);
 
  return () => {
    window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    window.removeEventListener('appinstalled', handleAppInstalled);
  };
}, []);
 
// Add this function inside your Tab2 component (alongside your other functions)
// const handleInstallClick = async () => {
//   if (isInStandaloneMode) {
//     setAlertHeader("✅ Already Installed");
//     setAlertMessage("This app is already installed on your device.");
//     setShowInstallAlert(true);
//     return;
//   }
 
//   if (isIos && !isInStandaloneMode) {
//     setAlertHeader("📱 iOS Install Instructions");
//     setAlertMessage(
//       "To install this app on your iPhone or iPad:\n\n" +
//       "1. Tap the Share button (📤) at the bottom of Safari\n" +
//       "2. Scroll down and tap 'Add to Home Screen'\n" +
//       "3. Tap 'Add' to confirm\n\n" +
//       "The app will appear on your home screen like a native app!"
//     );
//     setShowInstallAlert(true);
//     return;
//   }
 
//   if (deferredPrompt) {
//     try {
//       deferredPrompt.prompt();
//       const choiceResult = await deferredPrompt.userChoice;
     
//       if (choiceResult.outcome === 'accepted') {
//         console.log('✅ User accepted the install prompt');
//       } else {
//         console.log('❌ User dismissed the install prompt');
//       }
     
//       setDeferredPrompt(null);
//       // Don't hide the button, keep it visible
//     } catch (error) {
//       console.error('Error during install prompt:', error);
//       setAlertHeader("⚠️ Installation Error");
//       setAlertMessage("There was an error trying to install the app. Please try again.");
//       setShowInstallAlert(true);
//     }
//   } else {
//     // Fallback for when no install prompt is available
//     setAlertHeader("⚠️ Installation Not Available");
//     setAlertMessage(
//       "App installation may not be available due to:\n\n" +
//       "• Browser doesn't support PWA installation\n" +
//       "• You're in private/incognito mode\n" +
//       "• App is already installed\n" +
//       "• Ad blockers or extensions are interfering\n\n" +
//       "Try using Chrome, Edge, or Safari in normal mode."
//     );
//     setShowInstallAlert(true);
//   }
// };
 
 
 const [userOS, setUserOS] = useState<string>('');
  const [isDownloading, setIsDownloading] = useState<boolean>(false);

  // Detect user's operating system
  useEffect(() => {
    const detectOS = () => {
      const userAgent = window.navigator.userAgent;
      if (/iPad|iPhone|iPod/.test(userAgent)) {
        setUserOS('iOS');
      } else if (/Android/.test(userAgent)) {
        setUserOS('Android');
      } else {
        setUserOS('Desktop');
      }
    };
    detectOS();
  }, []);

  // Handle app installation based on device type
  // const handleInstallClick = () => {
  //   if (isDownloading) return;

  //   setIsDownloading(true);

  //   switch (userOS) {
  //     case 'Android':
  //       downloadAndroidApp();
  //       break;
  //     case 'iOS':
  //       downloadiOSApp();
  //       break;
  //     case 'Desktop':
  //       handleDesktopDownload();
  //       break;
  //     default:
  //       handleGenericDownload();
  //   }

  //   // Reset downloading state after 3 seconds
  //   setTimeout(() => {
  //     setIsDownloading(false);
  //   }, 3000);
  // };



// const handleInstallClick = async (order: any) => {
//   try {
//     setShowLoading(true);

//     // Call API to download the APK
//     const response = await Authservice.downloadApk(usertoken);

//     if (response && response.status === 200) {
//       // Create a download link for the APK
//       const apkBlob = new Blob([response.data], { type: "application/vnd.android.package-archive" });
//       const apkUrl = window.URL.createObjectURL(apkBlob);

//       const link = document.createElement("a");
//       link.href = apkUrl;
//       link.setAttribute("download", "atmagram.apk"); // Force download
//       document.body.appendChild(link);
//       link.click();
//       document.body.removeChild(link);

//       alert({
//         header: "Atmagram",
//         message: "APK download started successfully.",
//         backdropDismiss: false,
//         buttons: ["OK"],
//       });
//     } else {
//       alert({
//         header: "Atmagram",
//         message: response?.message || "Failed to download APK.",
//         backdropDismiss: false,
//         buttons: ["Ok"],
//       });
//     }
//   } catch (error) {
//     alert({
//       header: "Atmagram",
//       message: "Something went wrong while downloading the APK.",
//       backdropDismiss: false,
//       buttons: ["Ok"],
//     });
//   } finally {
//     setShowLoading(false);
//   }
// };

const handleInstallClick = async (usertoken:any) => {
  try {
    console.log('Starting APK download...');
    const response =  await Authservice.downloadApk(usertoken);
    // Create blob with correct MIME type (matching your backend)
    const blob = new Blob([response.data], { 
      type: 'application/vnd.android.package-archive' 
    });
    // Create download URL
    const downloadUrl = window.URL.createObjectURL(blob);
    // Create temporary link and trigger download
    const link = document.createElement('a');
    link.href = downloadUrl;
    link.download = 'atmagram.apk'; // Matches filename from your backend
    link.style.display = 'none';
    // Add to DOM, click, and remove
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    // Clean up the URL object
    window.URL.revokeObjectURL(downloadUrl);
    console.log('APK download completed successfully');
    return { success: true, message: 'Download completed' };
  } catch (error) {
    console.error('APK download failed:', error);
    return { 
      success: false, 
      message: error instanceof Error ? error.message : 'Download failed' 
    };
  }
};

  // Android APK download
  const downloadAndroidApp = async () => {
    try {
      const cacheBuster = Date.now();
      // 1) Try to download the static file shipped with the frontend build
      const staticUrl = `/downloads/atmagram.apk?t=${cacheBuster}`;
      let response = await fetch(staticUrl, {
        method: 'GET',
        headers: {
          Accept: 'application/vnd.android.package-archive',
        },
        cache: 'no-store',
        redirect: 'follow',
      });

      // If static failed or was rewritten to HTML, fall back to backend endpoint
      if (!response.ok || (response.headers.get('content-type') || '').includes('text/html')) {
        const apiBaseUrl = (process.env.REACT_APP_API_BASE_URL || '').trim() || window.location.origin;
        const apiUrl = `${apiBaseUrl}/downloads/atmagram/apk?t=${cacheBuster}`;
        response = await fetch(apiUrl, {
          method: 'GET',
          headers: { Accept: 'application/vnd.android.package-archive' },
          cache: 'no-store',
          redirect: 'follow',
        });
        if (!response.ok) {
          throw new Error(`HTTP ${response.status}`);
        }
      }

      const contentType = response.headers.get('content-type') || '';
      if (contentType.includes('text/html')) {
        throw new Error('Received HTML instead of APK (likely routed to index.html)');
      }

      const blob = await response.blob();
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.download = 'atmagram.apk';
      link.style.display = 'none';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(downloadUrl);

      setTimeout(() => {
        alert('APK downloaded! Please check your downloads folder.');
      }, 500);
    } catch (error) {
      console.error('Android download failed:', error);
      alert('Download failed. Please try again.');
    }
  };

  // iOS app installation
  const downloadiOSApp = () => {
    try {
      // Option 1: TestFlight (Recommended for beta testing)
      // window.open('https://testflight.apple.com/join/YOUR-TESTFLIGHT-CODE', '_blank');
      
      // Option 2: App Store (When published)
      // window.open('https://apps.apple.com/app/your-app-id', '_blank');
      
      // Option 3: Direct IPA download (Limited compatibility)
      const ipaUrl = process.env.PUBLIC_URL + '/downloads/atmagram-app.ipa';
      window.open(ipaUrl, '_blank');
      
      // Show installation instructions
      setTimeout(() => {
        alert('For iOS installation, you may need to trust the developer certificate in Settings → General → Device Management after download.');
      }, 1000);
    } catch (error) {
      console.error('iOS download failed:', error);
      alert('Download failed. Please visit the App Store or use TestFlight.');
    }
  };

  // Desktop users - redirect to mobile or show QR
  const handleDesktopDownload = () => {
    const isMobile = window.confirm(
      'This app is designed for mobile devices. Would you like to:\n\n' +
      'OK - Send link to your phone\n' +
      'Cancel - Download anyway'
    );

    if (isMobile) {
      // Option 1: Show QR code or send SMS
      showMobileOptions();
    } else {
      // Option 2: Let them download anyway
      downloadAndroidApp();
    }
  };

  // Show mobile download options
  const showMobileOptions = () => {
    const phoneNumber = prompt('Enter your phone number to receive download link:');
    if (phoneNumber) {
      // Here you would typically send SMS with download link
      // For now, just copy link to clipboard
      const downloadLink = `${window.location.origin}/download`;
      navigator.clipboard.writeText(downloadLink).then(() => {
        alert(`Download link copied to clipboard!\nShare this link: ${downloadLink}`);
      }).catch(() => {
        alert(`Please visit this link on your mobile device: ${downloadLink}`);
      });
    }
  };

  // Generic download for unknown devices
  const handleGenericDownload = () => {
    const choice = window.confirm(
      'Choose your platform:\n\nOK - Android APK\nCancel - iOS App'
    );
    
    if (choice) {
      downloadAndroidApp();
    } else {
      downloadiOSApp();
    }
  };

  // Get appropriate tooltip text based on device
  const getTooltipText = (): string => {
    if (isDownloading) return 'Downloading...';
    
    switch (userOS) {
      case 'Android':
        return 'Download Android App';
      case 'iOS':
        return 'Download iOS App';
      // case 'Desktop':
      //   return 'Get Mobile App';
      default:
        return 'Add to Homescreen';
    }
  };

  // Get appropriate icon or use existing image
  const getIconStyle = () => ({
    width: "25px",
    height: "25px",
    cursor: isDownloading ? "not-allowed" : "pointer",
    opacity: isDownloading ? 0.6 : 1,
    filter: isDownloading ? "grayscale(100%)" : "none",
    transition: "all 0.3s ease"
  });

  const [formErrors, setFormErrors] = useState({
    email: '',
    password: '',
    phone: "",
    otp: ""
  });
  const [alert] = useIonAlert();
  const phoneInputRef = useRef(null)
  const moveCursorToEnd = (value: any) => {
    const input: any = phoneInputRef.current;
    if (widthSize <= 500) {
      if (input) {
        setTimeout(() => {
          input.focus();
          input.setSelectionRange(input.value.length, input.value.length);
        }, 0);
      }
    }
    try {
      const phoneNumberObject: any = parsePhoneNumberFromString(value);
      setIsValidPhoneNumber(phoneNumberObject ? phoneNumberObject.isValid() : false);
    } catch (error) {
      setIsValidPhoneNumber(false);
      console.log(error)
    }
    setPhone(value)
  };
  const verifyOTP = () => {
    // var credential = PhoneAuthProvider.credential(confirmationResult.verificationId, otp);
    // console.log(credential);
    const errors: any = {};
    if (otp === undefined || otp === "" || otp == null) {
      errors.otp = "Enter OTP"
    }
    setFormErrors(errors);
    console.log(formErrors)
    if (Object.keys(errors).length === 0) {
      confirmationResult.confirm(otp).then((result: any) => {
        // User signed in successfully.
        const user = result.user;
        console.log(result);
        setShowLoading(true);
        AuthService.mobileLogin(phone)
          .then((response) => {
            if (response.data.responseText.startsWith("SUCCESS")) {
              if (response.data.userModel.uflag === "false") {
                alert("Your account is not active, Please contact Atmagram")
              }
              else {
                console.log(response.data)
                sessionStorage.setItem("token", response.data.userToken);
                sessionStorage.setItem("UserId", response.data.userModel.userId);
                sessionStorage.setItem("uFlag", response.data.userModel.uflag);
                sessionStorage.setItem("UserData", response.data.userModel.role);
                sessionStorage.setItem("Email", response.data.userModel.email);
                sessionStorage.setItem("Phone", response.data.userModel.mobileNumber);
                setUFlag(response.data.userModel.uflag)
                setToken(response.data.userToken)
                setUserData(response.data.userModel.role)
                if (response.data.userModel.address !== null) {
                  sessionStorage.setItem("Address", response.data.userModel.address);
                }
                if (response.data.userModel.firstName !== null) {
                  sessionStorage.setItem("Name", response.data.userModel.firstName);
                }
                if (response.data.userModel.lastName !== null) {
                  sessionStorage.setItem("lastName", response.data.userModel.lastName);
                }
                var usrRole = response.data.userModel.role;
                history.replace("/")

              }
              var usrToken = response.data.userToken;
              if (token != null && token != undefined && token != "") {
                Authservice.VerifyMobileChange(token, usrToken).then((response) => {
                  if (response.data.startsWith("SUCCESS")) {
                    alert(response.data.split('SUCCESS:')[1]);
                    token = null;
                    history.push("/profile")
                    return;
                  } else {
                    alert(response.data.split('ERROR:')[1]);
                    token = null;
                    history.replace("/")
                    return;
                  }
                  console.log(response + "mobRes")
                })
                  .catch((error) => {
                    console.log(error + "mobErr")
                  });
              } else {
                // if (Capacitor.getPlatform() === "web") {
                //   window.location.reload();
                // } else {
                //   history.goBack();

                // }


              }


            } else {
              alert(response.data.responseText.split("ERROR:")[1]);
            }
            setShowLoading(false);
          })
          .catch((error) => {
            console.log(error);
            setShowLoading(false);
          });

        // ...
      }).catch((err: any) => {
        // User couldn't sign in (bad verification code?)
        console.log(err.error);
        alert("Not a valid verification code or Code expired, please try again")


        // if(error.error.message=='SESSION_EXPIRED'){
        //   alert("OTP expired");
        // }else{

        // }
        // ...
      });
    }


  }
  const checkMobile = () => {
    const errors: any = {};
    if (phone === undefined || phone === "") {
      errors.phone = "Mobile Number is required"
    } else if (!isValidPhoneNumber) {
      errors.phone = "Enter valid Mobile Number"
    }
    setFormErrors(errors);
    console.log(formErrors)
    if (Object.keys(errors).length === 0) {
      setShowLoading(true);
      AuthService.validMob(phone).then((res) => {
        setShowLoading(false);
        if (res.data) {
          getOTP();
        } else {
          alert("Please complete registration. Then only you can login with Atmagram")
        }

      }).catch((error) => {
        console.log(error);
        setShowLoading(false);
      });
    }
  }

  const getOTP = () => {
    let verify = new RecaptchaVerifier('recaptcha-container', {
      'size': 'normal',
      'callback': (response: any) => {
        // reCAPTCHA solved, allow signInWithPhoneNumber.
        // ...
      },
      'expired-callback': () => {
        // Response expired. Ask user to solve reCAPTCHA again.
        // ...
        alert("Response expired. Please solve reCAPTCHA again")
      }
    }, auth);

    signInWithPhoneNumber(auth, phone, verify)
      .then((confirmationResult) => {
        // SMS sent. Prompt user to type the code from the message, then sign the
        // user in with confirmationResult.confirm(code).
        console.log(confirmationResult);
        setShowOtp(true)
        setconfirmationResult(confirmationResult)
        // ...
      }).catch((error) => {
        // Error; SMS not sent
        console.log("mob error" + error)
        alert("Something went wrong, please try again later.")
        // ...
      });
  }

  const fetchDetails = async () => {
    const details = await fetchUserDetails();
    console.log(JSON.stringify(details));
    setLogInfo(JSON.stringify(details));
  };

  useEffect(() => {
    fetchDetails();
  }, []);

  useEffect(() => {
    if (!load) {
      if (userdata != null) {
        //history.goForward();
        // history.replace("/")
        sessionStorage.clear()
      }
      load = true;
    }

    console.log(local.state)
  }, []);

  const [alertmodal, setAlertmodal] = useState(false)
  const [alertdata, setAlertdata] = useState("")
  const ForgetSubmit = () => {
    setShowLoading(true);
    AuthService.Forgotpassword(passemail).then((response) => {

      if (response.data.startsWith("SUCCESS")) {
        console.log(response.data)
        var res = response.data.split('SUCCESS:')[1];
        alertmodalaction(true, "Reset password link sent to your Email Id!")

        setShowLoading(false);

      } else {
        setShowLoading(false);
        alertmodalaction(true, "Account Not Found")
      }

    })
      .catch((error) => {
        console.log(error);
        setShowLoading(false);
      });
  };

  const alertmodalaction = (e: any, data: any) => {
    setAlertmodal(e)
    setAlertdata(data)
  }

  const alertmodalclose = () => {
    if (alertdata === "Reset password link sent to your Email Id!") {
      window.location.reload()
    }
    else {
      setAlertmodal(false)
      setAlertdata("")
    }
  }

  const handleBlur = () => {
    const inputValue: any = inputRef.current?.value;
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (inputValue === "") {
      setErrorMessage('Please enter a email address');
      errorMessageRef.current?.setAttribute('aria-errormessage', 'email-error');
    }
    else if (!emailPattern.test(inputValue!)) {
      setErrorMessage('Please enter a valid email address');
      errorMessageRef.current?.setAttribute('aria-errormessage', 'email-error');
    } else {
      setErrorMessage('');
      errorMessageRef.current?.removeAttribute('aria-errormessage');
    }
  };
  const Submit = () => {
    const errors: any = {};

    if (email.trim() === '') {
      errors.email = 'Email is required';
    }
    else if (validator.isEmail(email) === false) {
      errors.email = "Enter Valid Email Address";
    }

    if (password.trim() === '') {
      errors.password = 'Password is required';
    }

    setFormErrors(errors);

    if (Object.keys(errors).length === 0) {
      setShowLoading(true);
      AuthService.Login(email, password, logInfo)
        .then((response) => {
          console.log(response)
          if (response.data.responseText.startsWith("SUCCESS")) {
            if (response.data.userModel.uflag === "false") {
              alert("Your account is not active, Please contact Atmagram")
            }
            else {
              var usrRole = response.data.userModel.role;

              if (usrRole === "ROLE_ADMIN") {
                history.push("/")
                // history.push("/admin_page")
              }
              // else if (usrRole === "ROLE_TEMPADMIN") {
              //   history.push("/tempadmin")
              // }
              else if (usrRole === "ROLE_VENDOR") {
                history.push("/")
              }
              // else if (usrRole === "ROLE_PROJECTADMIN") {
              //   history.push("/projectadmin")
              // }
              else if (usrRole === "ROLE_USER" || usrRole === "ROLE_VOLUNTEER" || usrRole === "ROLE_FINANCE") {
                history.replace("/")
              }
              if (Capacitor.getPlatform() === "web") {
                console.log(response.data)
                setUFlag(response.data.userModel.uflag)
                setToken(response.data.userToken)
                setUserData(response.data.userModel.role)
                sessionStorage.setItem("token", response.data.userToken);
                // sessionStorage.setItem("UserId", response.data.userModel.id);
                sessionStorage.setItem("UserId", response.data.userModel.userId);
                sessionStorage.setItem("uFlag", response.data.userModel.uflag);
                sessionStorage.setItem("UserData", response.data.userModel.role);
                sessionStorage.setItem("Email", response.data.userModel.email);
                sessionStorage.setItem("Phone", response.data.userModel.mobileNumber);
                if (response.data.userModel.address !== null) {
                  sessionStorage.setItem("Address", response.data.userModel.address);
                }
                if (response.data.userModel.firstName !== null) {
                  sessionStorage.setItem("Name", response.data.userModel.firstName);
                }
                if (response.data.userModel.lastName !== null) {
                  sessionStorage.setItem("lastName", response.data.userModel.lastName);
                }
              }
              else {
                if (response.data.userModel.role === "ROLE_TEMPADMIN" || response.data.userModel.role === "ROLE_VENDOR" || response.data.userModel.role === "ROLE_USER") {
                  sessionStorage.setItem("token", response.data.userToken);
                  sessionStorage.setItem("UserId", response.data.userModel.id);
                  sessionStorage.setItem("UserData", response.data.userModel.role);
                  sessionStorage.setItem("uFlag", response.data.userModel.uflag);
                  sessionStorage.setItem("Email", response.data.userModel.email);
                  setUFlag(response.data.userModel.uflag)
                  setToken(response.data.userToken)
                  setUserData(response.data.userModel.role)
                  sessionStorage.setItem("Phone", response.data.userModel.mobileNumber);
                  if (response.data.userModel.address !== null) {
                    sessionStorage.setItem("Address", response.data.userModel.address);
                  }
                  if (response.data.userModel.firstName !== null) {
                    sessionStorage.setItem("Name", response.data.userModel.firstName);
                  }
                  if (response.data.userModel.lastName !== null) {
                    sessionStorage.setItem("lastName", response.data.userModel.lastName);
                  }
                  // alert("Login Successful");
                  console.log(response.data.userModel.role);
                  //history.push("/home");
                  //window.location.reload();
                } else {
                  alert("User Not Authorized For Mobile App. Please visit Web Application")
                }
              }
              var usrToken = response.data.userToken;

              if (token != null && token != undefined && token != "") {
                Authservice.VerifyMobileChange(token, usrToken).then((response) => {
                  if (response.data.startsWith("SUCCESS")) {
                    alert(response.data.split('SUCCESS:')[1]);
                    token = null;

                    history.push("/profile")
                    return;

                  } else {
                    alert(response.data.split('ERROR:')[1]);
                    token = null;

                    history.replace("/")
                    return;


                  }
                  console.log(response + "mobRes")
                })
                  .catch((error) => {
                    console.log(error + "mobErr")
                  });
              } else {
                // if (Capacitor.getPlatform() === "web") {
                // window.location.reload();
                // } else {
                //   history.goBack();

                // }

              }
            }
          } else {
            alert(response.data.responseText.split("ERROR:")[1]);
          }
          setShowLoading(false);
        })
        .catch((error) => {
          console.log(error);
          setShowLoading(false);
          // alert("Something went wrong, please try again later.");
        });
    }
  };

  const Validation = (label: any) => {

    if (label === "email") {
      if (email.trim() === '') {
        setFormErrors((prev: any) => {
          return { ...prev, email: 'Email is required' }
        })
      }
      else if (validator.isEmail(email) === false) {
        setFormErrors((prev: any) => {
          return { ...prev, email: "Enter Valid Email Address" }
        })
      }
      else {
        setFormErrors((prev: any) => {
          return { ...prev, email: "" }
        })
      }
    }

    if (label === "password") {
      if (password.trim() === '') {
        setFormErrors((prev: any) => {
          return { ...prev, password: 'Password is required' }
        })
        // errors.password = 'Password is required';
      }
      else {
        setFormErrors((prev: any) => {
          return { ...prev, password: "" }
        })
      }
    }

    if (label === "phone") {
      if (phone === undefined || phone === "") {
        setFormErrors((prev: any) => {
          return { ...prev, phone: "Mobile Number is required" }
        })
      } else if (!isValidPhoneNumber) {
        setFormErrors((prev: any) => {
          return { ...prev, phone: "Enter valid Mobile Number" }
        })
      }
      else {
        setFormErrors((prev: any) => {
          return { ...prev, phone: "" }
        })
      }
    }

    if (label === "otp") {
      if (otp === undefined || otp === "" || otp == null) {
        setFormErrors((prev: any) => {
          return { ...prev, otp: "Enter OTP" }
        })
      }
      else {
        setFormErrors((prev: any) => {
          return { ...prev, otp: "" }
        })
      }
    }

    // const error = Validation(label,value);
    // setFormErrors((prevErrors) => ({ ...prevErrors, [label.toLowerCase()]: error }));
  }
  const ChangeValidation = (label: any, e: any) => {

    if (label === "email") {
      const email = e.target.value;
      if (email.trim() === '') {
        setFormErrors((prev: any) => {
          return { ...prev, email: 'Email is required' }
        })
      }
      else if (validator.isEmail(email) === false) {
        setFormErrors((prev: any) => {
          return { ...prev, email: "Enter Valid Email Address" }
        })
      }
      else {
        setFormErrors((prev: any) => {
          return { ...prev, email: "" }
        })
      }
    }

    if (label === "password") {
      const password = e.target.value;
      if (password.trim() === '') {
        setFormErrors((prev: any) => {
          return { ...prev, password: 'Password is required' }
        })
        // errors.password = 'Password is required';
      }
      else {
        setFormErrors((prev: any) => {
          return { ...prev, password: "" }
        })
      }
    }

    if (label === "phone") {
      const phone = e;

      let valid: any = false
      try {
        const phoneNumberObject: any = parsePhoneNumberFromString(e);
        valid = phoneNumberObject ? phoneNumberObject.isValid() : false;
      } catch (error) {
        valid = false;
        console.log(error)
      }

      if (phone === undefined || phone === "") {
        setFormErrors((prev: any) => {
          return { ...prev, phone: "Mobile Number is required" }
        })
      } else if (!valid) {
        setFormErrors((prev: any) => {
          return { ...prev, phone: "Enter valid Mobile Number" }
        })
      }
      else {
        setFormErrors((prev: any) => {
          return { ...prev, phone: "" }
        })
      }
    }

    if (label === "otp") {
      const otp = e.target.value;
      if (otp === undefined || otp === "" || otp == null) {
        setFormErrors((prev: any) => {
          return { ...prev, otp: "Enter OTP" }
        })
      }
      else {
        setFormErrors((prev: any) => {
          return { ...prev, otp: "" }
        })
      }
    }

    // const error = Validation(label,value);
    // setFormErrors((prevErrors) => ({ ...prevErrors, [label.toLowerCase()]: error }));
  }

  const SearchF = (value: any) => {
    if (value == "Enter") {
      Submit()
    }
  }
  const phoneLogin = () => {
    setIndex(1)

  }
  const emailLogin = () => {
    setIndex(0)
  }
  const goBack = () => {
    setShowOtp(false)
  }
  // }
  //   const signIn  = ()=> {

  //     const result =  Plugins.GoogleAuth.signIn();
  //     console.info('result', result);
  //     if (result) {
  //       // history.push({
  //       //   pathname: '/home',
  //       //   state: { name: result.name || result.displayName, image: result.imageUrl, email: result.email }
  //       // });
  //       console.log("name"+ result.name+"displayName"+result.displayName)
  //     }

  // googleLogin();

  //   }

  const handleGoogleSignUp = async () => {
    try {
      const result = await signInWithPopup(auth, provider);
      console.log("User Info:", result.user);
      alert(`Welcome, ${result.user.displayName}`);
    } catch (error) {
      console.error("Google Sign-In Error:", error);
    }
  };


  return (
    <IonPage>
      <IonContent>
        <div className="head_login">
          <HeadFoot User={"login"} Role="Role" Name="Home,Login" />
        </div>


        <IonLoading message="Loading..." spinner={null}
          isOpen={showLoading}
        // onDidDismiss={() => setShowLoading(false)}
        // duration={5000}
        />
        {/* <UserHead Role={userdata[0]} User="login" /> */}
        <Modal show={forpassmodal} className="profile-modal">
          <ModalHeader className="profilenodal-Header">
            <h2 className="profileModal-title">Forgot Password</h2>
            <div>

              <IonIcon src={close} className="close_icon" onClick={() => setforpassmodal(false)} />
            </div>
          </ModalHeader>
          <Modal.Body>

            <IonRow>
              <IonCol size="12">
                <IonLabel className="form-labels">
                  Email
                </IonLabel>
                <IonInput
                  type="email"
                  value={passemail}
                  required
                  placeholder="Enter registered email-id"
                  onIonChange={(e) => setPassemail(e.detail.value!)}
                  ref={inputRef}
                  onBlur={handleBlur}
                  className="profile-inputs"
                  aria-errormessage="email-error"
                ></IonInput>
                {errorMessage && <span className="alert_input_bottom " ref={errorMessageRef} id="email-error" color="danger">{errorMessage}</span>}
              </IonCol>
            </IonRow>
            <div className={passemail.length == 0 || validator.isEmail(passemail) === false ? "disableCursor" : ""} style={{ width: "fit-content" }}>
              <IonButton disabled={passemail.length == 0 || validator.isEmail(passemail) === false} onClick={() => ForgetSubmit()}>
                <span className="button_padding">Submit</span>
              </IonButton>
            </div>
          </Modal.Body>
        </Modal>
        <Modal show={alertmodal} className="login_alert_modal" centered>
          <Modal.Body>
            <div style={{ textAlign: "center" }}>
              <h5 className="login_alert_title">Atmagram</h5>
            </div>
            <div style={{ textAlign: "center" }}>
              <IonText>{alertdata}</IonText>
            </div>
            <div style={{ textAlign: "right", paddingTop: "15px" }}>
              <IonText style={{ cursor: "pointer" }} onClick={() => alertmodalclose()}>OK</IonText>
            </div>
          </Modal.Body>
        </Modal>
        <IonRow className="page_container">
          <IonCol className="img_container" sizeLg="7.5" sizeMd="0" sizeXl="7.5" sizeSm="0" size="7.5" sizeXs="0" >
            <div className="tool_img" >
              <div className="logo_login">
                <Link to="/" style={{ textDecoration: "none" }}>
                  <IonImg className="logo_class" src={logo} ></IonImg>
                </Link></div>
            </div>
          </IonCol>
          <IonCol sizeLg="4.5" sizeMd="12" sizeXl="4.5" sizeSm="12" size="4.5" sizeXs="12">
            <div className="register_login_title">
              <Link to="/" >
                <IonIcon src={home} className="home_icon">
                </IonIcon>
              </Link>
 {/* <IonIcon src={downloadOutline} className="download_icon"
               onClick={() => handleInstallClick()}>
                 </IonIcon> */}

               {/* Show only if install is available or iOS guidance needed */}
{/* {(showInstallButton || (isIos && !isInStandaloneMode)) && (
  <IonIcon
    icon={downloadOutline}
    className="download_icon"
    onClick={() => {
      if (isIos) {
        alert("To install the app, tap the 'Share' icon in Safari and choose 'Add to Home Screen'.");
      } else {
        handleInstallClick();
      }
    }}
  />
)} */}

 
{/* <div className="tooltip-container">
  <IonIcon
    icon={linkOutline}
    className="download_icon"
    onClick={() => {
      if (isInStandaloneMode) {
        setAlertHeader("✅ Already Installed");
        setAlertMessage("This app is already installed on your device.");
        setShowInstallAlert(true);
      } else if (isIos && !isInStandaloneMode) {
        setAlertHeader("📱 iOS Install Help");
        setAlertMessage(
          "To install this app on iPhone or iPad, tap the 'Share' icon in Safari and select 'Add to Home Screen'."
        );
        setShowInstallAlert(true);
      } else if (deferredPrompt) {
        handleInstallClick();
      } else {
        setAlertHeader("⚠️ Installation Alert");
        setAlertMessage(
          "App install may be blocked due to:\n\n• Unsupported browser\n• Private/incognito mode\n• Ad blockers or extensions\n• App already installed\n\nTry downloading in Chrome or Safari settings."
        );
        setShowInstallAlert(true);
      }
    }}
  />
  <span className="tooltip-text">Add to Homescreen</span>
</div> */}
 {userOS !== 'Desktop' && (
      <div className="tooltip-container">
        <img
          src={process.env.PUBLIC_URL + "/images/downloadUrl.jpg"}
          className="download_icon"
          onClick={downloadAndroidApp}
          alt="Install App"
          style={getIconStyle()}
          onError={(e) => {
            (e.target as HTMLImageElement).style.display = "none";
            console.error("Image not found: /images/downloadUrl.jpg");
          }}
        />
        <span className="tooltip-text">{getTooltipText()}</span>

        {/* Optional: Add loading indicator */}
        {isDownloading && (
          <div
            style={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              width: '15px',
              height: '15px',
              border: '2px solid #f3f3f3',
              borderTop: '2px solid #3498db',
              borderRadius: '50%',
              animation: 'spin 1s linear infinite',
              pointerEvents: 'none'
            }}
          />
        )}
      </div>
    )}
 



<IonAlert
  isOpen={showInstallAlert}
  onDidDismiss={() => setShowInstallAlert(false)}
  header={alertHeader}
  message={alertMessage.replace(/\n/g, "<br />")}
  buttons={["OK"]}
/>


            </div>
            <div className="login_top">
              {index == 0 ?
                <div className="login_container">
                  <form onSubmit={handleSubmit(Submit)} onKeyPress={e => SearchF(e.key)}>
                    <div>
                      <span className="login_head">Login</span>
                      <IonRow  >

                        <IonCol size="11" size-lg="7" className="email_container">
                          <div>

                            <IonLabel className="label_align">
                              E-mail <span style={{ color: "red" }}>*</span>
                            </IonLabel>

                            <IonInput className="select_user"
                              type="text"
                              style={{ textTransform: "none" }}
                              value={email} placeholder="Enter Email-id"
                              onIonChange={(e) => {
                                setEmail(e.detail.value!);
                                ChangeValidation("email", e)
                              }}
                              onBlur={(e) => Validation("email")}
                            // required
                            ></IonInput>
                            {/* <span slot="error">Name is required</span> */}

                          </div>
                          {formErrors.email && <span className="alert_input_bottom ">{formErrors.email}</span>}
                        </IonCol>
                      </IonRow>
                      <IonRow >

                        <IonCol size="11" className="pass_container" style={{ position: "relative" }}>
                          <div style={{ width: "100%" }}>
                            <IonLabel className="label_align">
                              Password <span style={{ color: "red" }}>*</span>
                            </IonLabel>
                            <IonInput
                              type={showPassword ? "text" : "password"}
                              style={{ textTransform: "none" }}
                              clearOnEdit={false} className="select_user" placeholder="Enter password"
                              onIonChange={(e) => { setPassword(e.detail.value!); ChangeValidation("password", e) }}
                              // required
                              onBlur={(e) => Validation("password")}
                            ></IonInput>
                            <div
                              className="eye_icon"
                              onClick={() => setShowPassword(!showPassword)}
                              style={{
                                position: "absolute",
                                right: "0px",
                                top: "50%",
                                cursor: "pointer",
                                zIndex: 1,
                              }}
                            >
                              <IonIcon icon={showPassword ? eyeOff : eye} />
                            </div>
                          </div>
                          {formErrors.password && <span className="alert_input_bottom ">{formErrors.password}</span>}
                        </IonCol>
                      </IonRow>
                      <IonRow>
                        <IonCol size="6" size-lg="6" className="pass_container" >
                          <div>
                            <Link to="/signup" className="forgot_pass_css">Don't have account?</Link>
                          </div>
                        </IonCol>
                        <IonCol size="6" size-lg="6" className="pass_container" >
                          <div style={{ textAlign: "right" }}>
                            <IonText onClick={() => setforpassmodal(true)} className="forgot_pass_css">Forgot Password?</IonText>
                          </div>
                        </IonCol>
                      </IonRow>
                      <IonRow className="login_btn_container">
                        <div className={email.length === 0 || password.length === 0 ? "disableCursor" : ""}>
                          <IonButton
                            type="submit"
                            disabled={email.length === 0 || password.length === 0}
                          >
                            <span className="button_padding"> Login</span>

                          </IonButton>
                        </div>
                      </IonRow>
                      <div className="center or_text_container">
                        <p>
                          or
                        </p>
                      </div>
                    </div>
                  </form>
                  <IonRow className="login_btn_container">
                    <IonButton onClick={phoneLogin}>
                      <span className="button_padding">  Login With Phone</span>
                    </IonButton>
                  </IonRow>
                  {/* <div style={{ width: "100%", justifyContent: "center", display: "flex", marginTop: "20px" }}>
                    <div className="google-signup" onClick={handleGoogleSignUp}>
                      <IonIcon icon={logoGoogle} className="google-icon" />
                      <span>Sign Up with Google</span>
                    </div>
                  </div> */}

                </div>
                : <div className="login_withmobile_container">
                  <span className="login_head">Login</span>
                  {!showOtp ? <>
                    <IonRow>
                      <IonCol size="11" size-lg="7" className="email_container">
                        <div>
                          <IonLabel className="label_align">
                            Mobile Number <span style={{ color: "red" }}>*</span>
                          </IonLabel>
                          <PhoneInput
                            international
                            defaultCountry="IN"
                            value={phone}
                            className="select_user"
                            ref={phoneInputRef}
                            // flags=false
                            onBlur={(e) => Validation("phone")}
                            onChange={(value: any) => { moveCursorToEnd(value); ChangeValidation("phone", value) }}
                          />

                        </div>
                        {formErrors.phone && <span className="alert_input_bottom ">{formErrors.phone}</span>}
                      </IonCol>
                    </IonRow>

                    <IonRow>
                      <IonCol size="11" size-lg="7" className="pass_container">
                        <div id="recaptcha-container"></div>
                      </IonCol>
                    </IonRow>
                    <IonRow className="login_btn_container">
                      <div className={phone === undefined || phone === "" || !isValidPhoneNumber ? "cursor_block" : ""}>
                        <IonButton
                          onClick={checkMobile}
                          disabled={phone === undefined || phone === "" || !isValidPhoneNumber}
                        >
                          <span className="button_padding"> Get OTP</span>
                        </IonButton>
                      </div>
                    </IonRow>
                  </> : <></>}

                  {showOtp ?
                    <>
                      <IonRow>
                        <IonCol size="11" size-lg="7" className="email_container">

                          <IonLabel className="label_align">
                            Enter OTP <span style={{ color: "red" }}>*</span>
                          </IonLabel>
                          <IonInput className="select_user"
                            onBlur={(e) => Validation("otp")}
                            onIonChange={(e) => { setOtp(e.detail.value!); ChangeValidation("otp", e) }}
                            required
                          ></IonInput>

                          {formErrors.otp && <span className="alert_input_bottom ">{formErrors.otp}</span>}
                        </IonCol>
                      </IonRow>

                      <IonRow>
                        <IonCol size="11" size-lg="7" className="pass_container" >
                          <span className="go_back_style"
                            onClick={goBack}
                          >go back
                          </span>
                        </IonCol>
                      </IonRow>

                      <IonRow className="login_btn_container">
                        <IonButton onClick={verifyOTP}>
                          <span className="button_padding">Verify OTP</span>
                        </IonButton>
                      </IonRow>
                    </> : <></>
                  }

                  <div className="center or_text_container"><p>
                    or</p></div>
                  <IonRow className="login_btn_container">
                    <IonButton onClick={emailLogin}>
                      <span className="button_padding"> Login With Email</span>
                    </IonButton>
                  </IonRow>
                </div>

              }


            </div>

            {/* {Capacitor.getPlatform() === "web"? */}

            {/* :<></>}  */}
          </IonCol>
        </IonRow>
        {/* <Foot /> */}
      </IonContent>
    </IonPage>
  );
};

export default Tab2;